(function() {
	'use strict';

	angular.module('quantixApp').controller('userBenchmarkData',
			userBenchmarkData);

	userBenchmarkData.$inject = [ '$rootScope','$stateParams', '$scope', '$state',
			'$location', 'GenericService', '$http',
			'$uibModal', '$timeout', '$translate', '$anchorScroll', '$window',
			'ErrorHandlerService', 'BENCHMARKS', '$compile' ];
	function userBenchmarkData($rootScope,$stateParams, $scope, $state, $location,
			GenericService, $http, $uibModal,
			$timeout, $translate, $anchorScroll, $window, ErrorHandlerService,
			BENCHMARKS, $compile) {
		$anchorScroll();
		$scope.tabid = 1;
		var formulaFlag = false;

		var childScope;
		
		$scope.oneYear = false;
		$scope.twoYear = false;
		$scope.threeYear = false;
		$scope.userSectionAccessData={};
		$scope.commonYearsModel=false;
		$scope.fiveYearList = [];
		$scope.finalYearList = [];
		$scope.portfolioId = $stateParams.portfolioId;
		$scope.portfolioType=$stateParams.portfolioType;
		$scope.portfolioDateTime=$stateParams.portfolioDateTime;
		if ($stateParams.portfolioId == null
				|| !angular.isDefined($stateParams.portfolioId)) {
			$state.go('portfolioDashboard')
		}
		$scope.selectedPortName= $stateParams.portfolioName;
		
		
		
		/*
		 * $rootScope.$on('NonFinacialData', function(event, data) {
		 * 
		 * $scope.tabid=data;
		 * 
		 * });
		 */

		GenericService.getUserModuleAccessData().then(function(result){
			$scope.userModuleAccessData = result;
			if (!$scope.userModuleAccessData[BENCHMARKS]) {
				ErrorHandlerService.forbiddenError(BENCHMARKS);
				return;
			}
		});
		
		 GenericService.getUserSectionAccessData().then(function(result){
			 
			 $scope.userSectionAccessData =result;
			 
			 
		 })
		
		$scope.temptab = 1;
		$scope.temptab2 = $scope.temptab;
		$timeout(function() {
			$scope.getSelectedRange();
		}, 1000);
		$scope.accessdeniedForFinancialTab = false;
		$scope.accessdeniedMessageForFinancialTab = "";
		$scope.accessdeniedForNonFinTab = false;
		$scope.accessdeniedMessageForNonFinTab = "";
		
		
		
		$scope.getBackToPortfolioDetails=function(){
			$state.go('portfolioLanding', {
				'portfolioId' : $scope.portfolioId,
				'portfolioName' : $scope.selectedPortName,
				'portfolioType' : $scope.portfolioType,
				'portfolioDateTime': $scope.portfolioDateTime
			});
		}
		
		
		$scope.setInnerTabSetData = function(tabid) {
			$scope.temptab2 = tabid;

			if ($scope.temptab2 == 2
					&& $scope.userSectionAccessData['Benchmarks.Full Benchmark Financial'] != 'Y') {
				$scope.accessdeniedForFinancialTab = true;
				$scope.accessdeniedForNonFinTab = false;
				$scope.accessdeniedMessageForNonFinTab = "";
				$scope.accessdeniedMessageForFinancialTab = "This section is not available in your current subscription. To subscribe to the  latest version, please contact Helpdesk – productsupport@crisil.com / +91 22 33428001.";
			} else {
				$scope.accessdeniedForFinancialTab = false;
				$scope.accessdeniedMessageForFinancialTab = "";

			}

			if ($scope.temptab2 == 1 && $scope.isSubscribed == false) {
				$scope.accessdeniedForNonFinTab = false;
				$scope.accessdeniedMessageForNonFinTab = "This section is not available in your current subscription. To subscribe to the  latest version, please contact Helpdesk – productsupport@crisil.com / +91 22 33428001.";
			} else {
				$scope.accessdeniedForNonFinTab = false;
				$scope.accessdeniedMessageForNonFinTab = "";

			}
			 if($scope.temptab2 == 1)
				{
				
		/*			if ($scope.temptab == 1) {
						$("#toptab1").addClass("active");
					} else {
						$("#toptab1").removeClass("active");
					}
					if ($scope.temptab == 2) {
						$("#toptab2").addClass("active");
					} else {
						$("#toptab2").removeClass("active");
					}
					if ($scope.temptab == 3) {
						$("#toptab3").addClass("active");
					} else {
						$("#toptab3").removeClass("active");
					}*/
				 $scope.nonFinTab=true;
				 $scope.tabInfo($scope.temptab2);
			
				
/*					if ($scope.selectedPeerGroups.length != 0) {					
						var modalid = "#tabDataBox";
						$(modalid).modal('show');
				}else
										{
											
										$scope.setSelectedTab();
										}*/
				
				
				}else{
					$scope.setSelectedTab();
					
				}
			
			 if($scope.temptab2 == 2 || $scope.temptab2 == 3)
				{
				 
	/*				if ($scope.temptab == 1) {
						$("#toptab1").addClass("active");
					} else {
						$("#toptab1").removeClass("active");
					}				 
				 
					if ($scope.temptab == 2) {
						$("#toptab2").addClass("active");
					} else {
						$("#toptab2").removeClass("active");
					}
					if ($scope.temptab == 3) {
						$("#toptab3").addClass("active");
					} else {
						$("#toptab3").removeClass("active");
					}*/
				 //$scope.setSelectedTab();
				 $scope.tabInfo($scope.temptab2);
				console.log($scope.selectedPeerGroups);
/*				for (var count = 0; count < $scope.selectedPeerGroups.length; count++) {
					if ($scope.selectedPeerGroups[count].peerValue != '') {					
						var modalid = "#tabDataBox";
						$(modalid).modal('show');
				}else
										{
											$scope.temptab2 = 2;
										$scope.setSelectedTab();
										}
					}*/
				
				}else{
					$scope.setSelectedTab();
					
				}
			

		}

		$scope.setSelectedTab = function() {

			$scope.peerGroupTwoAddedFlag = true;
			$scope.peerGroupFourAddedFlag = false;
			$scope.peerGroupThreeAddedFlag = false;
			$scope.temptab = angular.copy($scope.temptab2);
			$scope.activeListStatus(1);
			$scope.selectedPeerGroups = [];

			$scope.showResult = false;
			$scope.filterCriteriaFlag = true;
			$scope.tabid = $scope.temptab;
			$scope.setActiveClasses();
			// $scope.validateData($scope.tabid);

			// added for unchecking peergroup
			$scope.peerGroupOneCheckedFlag = true;
			$scope.peerGroupTwoCheckedFlag = false;
			$scope.peerGroupThreeCheckedFlag = false;
			$scope.peerGroupFourCheckedFlag = false;

			// added for load directive
			$scope.isdeleted1 = true;
			$scope.isdeleted2 = false;
			$scope.isdeleted3 = false;
			$scope.isdeleted4 = false;

			if ($scope.tabid == 1) {
				//$scope.getSelectedRange();

			}

		}

		$scope.getPrevSelectedTab = function() {
			$scope.setActiveClasses();
		}

		$scope.setActiveClasses = function() {
/*			if ($scope.temptab == 1) {
				$("#toptab1").addClass("active");
			} else {
				$("#toptab1").removeClass("active");
			}

			if ($scope.temptab == 2) {
				$("#toptab2").addClass("active");
			} else {
				$("#toptab2").removeClass("active");
			}*/
			if ($scope.temptab == 1) {
				$("#toptab1").addClass("active");
			} else {
				$("#toptab1").removeClass("active");
			}
			if ($scope.temptab == 2) {
				$("#toptab2").addClass("active");
			} else {
				$("#toptab2").removeClass("active");
			}
			if ($scope.temptab == 3) {
				$("#toptab3").addClass("active");
			} else {
				$("#toptab3").removeClass("active");
			}

		}
		/*GenericService.getUserModuleAccessData().then(function(result){
			$scope.userModuleAccessData = result;
			if (!$scope.userModuleAccessData[BENCHMARKS]) {
				ErrorHandlerService.forbiddenError(BENCHMARKS);
				return;
			}
		});
*/
		var vm = this;
		$scope.operGrid = false;
		$scope.compare = false;
		var col = [];
		var financialValue = [];
		var financialTabValue = [];

		var operationalValue = [];
		var year = [];
		var yearCol = [];
		var yearForOperational = [];
		var yearColForOperational = [];
		var peerGroupsForFinancial = [];
		var peerGroupsForFinancialTab = [];
		var peerCol = [];
		var financialCol = [];
		var colCount = '';
		var operationlCol = [];
		$scope.showResult = false;
		$scope.showFinResult = false;

		$scope.filterCriteriaFlag = true;
		$scope.name1 = "selectedpeergroupone";
		$scope.name2 = "selectedpeergrouptwo";
		$scope.name3 = "selectedpeergroupthree";
		$scope.name4 = "selectedpeergroupfour";

		// added for unchecking peergroup
		$scope.peerGroupOneCheckedFlag = true;
		$scope.peerGroupTwoCheckedFlag = false;
		$scope.peerGroupThreeCheckedFlag = false;
		$scope.peerGroupFourCheckedFlag = false;

		// added for load directive
		$scope.isdeleted1 = true;
		$scope.isdeleted2 = false;
		$scope.isdeleted3 = false;
		$scope.isdeleted4 = false;

		var ratingGrid = '';
		var financialGrid = '';
		var financialTabGrid = '';

		var operationalGrid = '';
		$scope.isSubscribed = true;
		// Added by Deepali
		$scope.exportAllYear = false;
		// End by Deepali

		$scope.financialFilterOption = {};

		$scope.financialFilterOption.financialType = 'YEAR';
		$scope.financialFilterOption.financialPeerMinMaxFlag = 'NO';
		$scope.financialFilterOption.medianAggFlag = 'median';
		$scope.financialFilterOption.selectedPeerGroupForFilter = [];
		$scope.financialFilterOption.excludeNegativeNetworth = 'false';

		$scope.creditRatingRanges = [];
		$scope.subscriptionRange = [];

		$scope.selectedPeerGroups = new Array();
		$scope.selectedPeerGroupsToBeSaved = [];

		var peerGroup = [];
		vm.validateFilter = validateFilter;
		$scope.disableOperationalParameter = false;
		$scope.activeOutputForm = 1;
		$scope.activeInputForm = 1;
		$scope.operationEmptyDataFlag = false;

		$scope.setisDeleted = function(peerNumber) {

			if (peerNumber == 2) {
				// $rootScope.peerGroupName ="";
				$scope.isDeletedFlaflag = true;
				$rootScope.peerGroupName = 'PeerGroup1';
				$rootScope.excludeCompanies2 = "";
				$scope.peerGroupTwoCheckedFlag = false;
				$scope.peerGroupThreeAddedFlag = false;
				$scope.peerGroupTwoAddedFlag = true;
				$timeout(function() {
					$scope.activeListStatus(peerNumber - 1);
				}, 100);
				$rootScope.$broadcast("closepeer", {
					peername : "selectedpeergrouptwo"
				});

			}

			if (peerNumber == 3) {
				$scope.isDeletedFlaflag = true;
				$rootScope.excludeCompanies3 = "";
				$rootScope.peerGroupName = 'PeerGroup2';
				$scope.peerGroupThreeCheckedFlag = false;
				$scope.peerGroupFourAddedFlag = false;
				$scope.peerGroupThreeAddedFlag = true;
				$timeout(function() {
					$scope.activeListStatus(peerNumber - 1);
				}, 100);

				$rootScope.$broadcast("closepeer", {
					peername : "selectedpeergroupthree"
				});
			}

			if (peerNumber == 4) {
				$scope.isDeletedFlaflag = true;
				$rootScope.peerGroupName = 'PeerGroup3';
				$rootScope.excludeCompanies4 = "";
				$scope.peerGroupFourCheckedFlag = false;
				$scope.peerGroupFourAddedFlag = true;
				$timeout(function() {
					$scope.activeListStatus(peerNumber - 1);
				}, 100);

				$rootScope.$broadcast("closepeer", {
					peername : "selectedpeergroupfour"
				});

			}

		}

		$scope.peerGroupTwoAddedFlag = true;
		$scope.peerGroupThreeAddedFlag = false;
		$scope.peerGroupFourAddedFlag = false;

		$scope.getPeerGroups = function(peerGroupName) {
			if ($scope.isDeletedFlaflag == undefined)
				$rootScope.peerGroupName = peerGroupName;
		}
		$scope.addPeerGroup = function(peerNumber) {
			$scope.activeListStatus(peerNumber);
			if (peerNumber == 2) {
				$rootScope.peerGroupName = 'PeerGroup2';
				$scope.peerGroupTwoCheckedFlag = true;
				if ($scope.peerGroupThreeCheckedFlag) {
					$scope.peerGroupThreeAddedFlag = false;
				} else {
					$scope.peerGroupThreeAddedFlag = true;
				}
				$scope.peerGroupTwoAddedFlag = false;

			}

			if (peerNumber == 3) {
				$rootScope.peerGroupName = 'PeerGroup3';
				$scope.peerGroupThreeCheckedFlag = true;
				if ($scope.peerGroupFourCheckedFlag) {
					$scope.peerGroupFourAddedFlag = false;
				} else {
					$scope.peerGroupFourAddedFlag = true;
				}
				$scope.peerGroupThreeAddedFlag = false;
			}

			if (peerNumber == 4) {
				$rootScope.peerGroupName = 'PeerGroup4';
				$scope.peerGroupFourCheckedFlag = true;
				$scope.peerGroupFourAddedFlag = false;
			}
		}

		$scope.activeListStatus = function(peerNumber) {
			$("#tabListContainer li").removeClass('active');
			$("#peerGroupTabContainer .peerGroupTabContainer").removeClass(
					'in active');

			$("#peerGroupHeading" + peerNumber).addClass('active');
			$("#peerGroup" + peerNumber).addClass('in active');
		}

		// To show error and success messages
		$scope.showErrorMessages = function(messageContent) {
			$scope.iferror = true;
			$scope.errorMessages = messageContent;

			$timeout(function() {
				$scope.iferror = false;
				$scope.errorMessages = "";
			}, 10000);
		}

		$scope.showSuccessMessages = function(messageContent) {
			$scope.ifsuccess = true;
			$scope.successMessages = messageContent;

			$timeout(function() {
				$scope.ifsuccess = false;
				$scope.successMessages = "";
			}, 10000);
		}

		$scope.setisDeleted(true, 1);

		$scope.openInputFilterContainer = function() {

			if ($scope.activeOutputForm != 4) {
				if ($scope.loadgraph) {
					$scope.loadgraph = false;

				}
				if ($scope.loadgraphForFin) {
					$scope.loadgraphForFin = false;

				}
			}

			if ($scope.filterCriteriaFlag) {
				$scope.filterCriteriaFlag = false;
			} else {
				$scope.filterCriteriaFlag = true;
			}
		}

		$scope.validindlist = [];
		$scope.ranges = [];
		$scope.upperlimit = 0;
		$scope.upperLimitFlag = false;
		$scope.getSelectedRange = function() {

/*			$scope.userSectionAccessData = GenericService
					.getUserSectionAccessData();*/

			vm.range = {
				'minValue' : '',
				'maxVvalue' : ''
			};
			vm.rangeToComapare = new Array();

			if ($scope.userSectionAccessData['Benchmarks.Benchmarks 0-25 Cr'] == 'Y') {
				vm.range = {
					'minValue' : 0,
					'maxVvalue' : 25,
					'val' : '0-25'
				};
				vm.rangeToComapare.push(vm.range);
			}
			if ($scope.userSectionAccessData['Benchmarks.Benchmarks 25-50 Cr'] == 'Y') {
				vm.range = {
					'minValue' : 25,
					'maxVvalue' : 50,
					'val' : '25-50'
				};
				vm.rangeToComapare.push(vm.range);
			}
			if ($scope.userSectionAccessData['Benchmarks.Benchmarks 50-100 Cr'] == 'Y') {
				vm.range = {
					'minValue' : 50,
					'maxVvalue' : 100,
					'val' : '50-100'
				};
				vm.rangeToComapare.push(vm.range);
			}
			if ($scope.userSectionAccessData['Benchmarks.Benchmarks 100-250 Cr'] == 'Y') {
				vm.range = {
					'minValue' : 100,
					'maxVvalue' : 250,
					'val' : '100-250'
				};
				vm.rangeToComapare.push(vm.range);
			}

			if ($scope.userSectionAccessData['Benchmarks.Benchmarks 251 Cr & above'] == 'Y') {
				vm.range = {
					'minValue' : 250,
					'maxVvalue' : 1000000,
					'val' : '251+'
				}
				$scope.upperLimitFlag = true;
				vm.rangeToComapare.push(vm.range);

			}

			$scope.creditRatingRanges = [];
			$scope.creditRatingRanges = vm.rangeToComapare;

			// $scope.creditRatingRanges = $scope.ranges;
			if ($scope.creditRatingRanges.length == 0) {
				$scope.isSubscribed = false;
				$scope.accessdeniedForNonFinTab = true;
				$scope.accessdeniedMessageForNonFinTab = "This section is not available in your current subscription. To subscribe to the  latest version, please contact Helpdesk – productsupport@crisil.com / +91 22 33428001.";

			} else {
				$scope.isSubscribed = true;
				$scope.accessdeniedForNonFinTab = false;
				$scope.accessdeniedMessageForNonFinTab = "";
			}
			vm.cflag = false;
			vm.minValueforcrange = 0;
			vm.maxValueforcrange = 0;
			vm.range = {
				'minValue' : '',
				'maxVvalue' : '',
				'val' : ''
			};

			vm.rangeToComapare = new Array();
			if ($scope.creditRatingRanges.length != 1) {
				var j = 0;
				vm.cflag = false;
				vm.minValueforcrange = 0;
				vm.maxValueforcrange = 0;
				var started = 0;
				var comeOut = false;
				vm.range = {
					'minValue' : '',
					'maxVvalue' : ''
				};
				while (j < $scope.creditRatingRanges.length) {

					if (j < $scope.creditRatingRanges.length - 1) {
						while (!comeOut
								&& ($scope.creditRatingRanges[j].maxVvalue == $scope.creditRatingRanges[j + 1].minValue || $scope.creditRatingRanges[j].maxVvalue == $scope.creditRatingRanges[j + 1].minValue - 1)) {

							if (started == 0) {
								started = 1;
								vm.minValueforcrange = $scope.creditRatingRanges[j].minValue;
							}

							vm.maxValueforcrange = $scope.creditRatingRanges[j + 1].maxVvalue;
							j = j + 1;

							if (j >= $scope.creditRatingRanges.length - 1) {
								comeOut = true;
							}
						}
					} else {
						started = 0;
					}

					if (started == 1) {
						vm.range = {
							'minValue' : vm.minValueforcrange,
							'maxVvalue' : vm.maxValueforcrange
						};
					} else if (started == 0) {
						vm.minValueforcrange = $scope.creditRatingRanges[j].minValue;
						vm.maxValueforcrange = $scope.creditRatingRanges[j].maxVvalue;

						vm.range = {
							'minValue' : vm.minValueforcrange,
							'maxVvalue' : vm.maxValueforcrange
						};
						started = 0;

					}
					vm.rangeToComapare.push(vm.range);
					j = j + 1;
				}
			} else if ($scope.creditRatingRanges.length == 1) {
				vm.minValueforcrange = $scope.creditRatingRanges[0].minValue;
				vm.maxValueforcrange = $scope.creditRatingRanges[0].maxVvalue;

				vm.range = {
					'minValue' : vm.minValueforcrange,
					'maxVvalue' : vm.maxValueforcrange
				};
				vm.rangeToComapare.push(vm.range);
			}
			$scope.subscriptionRange = [];
			$scope.subscriptionRange = vm.rangeToComapare;
			// alert(angular.toJson($scope.userSectionAccessData));

			var industrySubscrptionlist = [];
			if ($scope.userSectionAccessData['Benchmarks.Industrial Manufacturing'] == 'Y') {
				industrySubscrptionlist.push('Industrial Manufacturing');
			}
			if ($scope.userSectionAccessData['Benchmarks.Consumer Products'] == 'Y') {
				industrySubscrptionlist.push('Consumer Products');
			}
			if ($scope.userSectionAccessData['Benchmarks.Consumer Services'] == 'Y') {
				industrySubscrptionlist.push('Consumer Services');
			}
			if ($scope.userSectionAccessData['Benchmarks.Industrial & Infrastructure Services'] == 'Y') {
				industrySubscrptionlist
						.push('Industrial & Infrastructure Services');
			}
			if ($scope.userSectionAccessData['Benchmarks.Materials'] == 'Y') {
				industrySubscrptionlist.push('Materials');
			}
			if ($scope.userSectionAccessData['Benchmarks.Trading & Distribution'] == 'Y') {
				industrySubscrptionlist.push('Trading & Distribution');
			}
			// if condition added by Bhaskara
			if (industrySubscrptionlist.length > 0) {
				var industrySubscrptionliststr = '';
				for (var i = 0; i < industrySubscrptionlist.length; i++) {
					if (i == (industrySubscrptionlist.length - 1)) {
						industrySubscrptionliststr = industrySubscrptionliststr
								+ "'" + industrySubscrptionlist[i] + "'";
					} else {
						industrySubscrptionliststr = industrySubscrptionliststr
								+ "'" + industrySubscrptionlist[i] + "',";
					}

				}

				if (industrySubscrptionliststr.length > 1) {
					$http.post(
							'api/userActivity/getIndustrySubscriptionForUser',
							industrySubscrptionliststr).success(
							function(response) {

								$rootScope.$broadcast("validIndustryList", {
									indlist : response
								});
								$scope.validindlist = response;
							}).error(function(response) {
					});
				} else {
					var indlistnone = [];
					$rootScope.$broadcast("validIndustryList", {
						indlist : indlistnone
					});
				}

			}
		}

		function validateFilter(from, to) {
			if (((from === null || from === undefined || from === ''))
					|| ((to === null || to === undefined || to === '' || to.length === 0))) {
				// alert("returning false validateFilter ")
				return false;
			}
			return true;
		}

		function validateFilterValues(from, to) {
			if (((from === null || from === undefined || from === ''))
					&& ((to === null || to === undefined || to === '' || to.length === 0))) {
				return true;
			}
			if (!(from === '') && !isNaN(from) && to != '' && !isNaN(to)) {
				return true;
			}
			return false;
		}
		$rootScope.$on('setUpperLimitForRevenue', function(event, args) {
			$scope.upperlimit = args.upperlimit;
		});

		$scope.validateData = function(temptab) {
			$scope.selectedPeerGroups=[];
			vm.creditOutOfRangeFlag = false;
			if (temptab == 1) {
					
				$scope.selectedPeerGroupsForPort = {
						'key' : 'PeerGroup1',
						'peerValue' : '',
						'location' : '',
						'salesTurnoverFrom' : '',
						'salesTurnoverTo' : '',
						'salesTurnoverUnit' : '',
						'totalDebtFrom' : '',
						'totalDebtTo' : '',
						'totalDebtUnit' : '',
						'ebitdaMarginFrom' : '',
						'ebitdaMarginTo' : '',
						'creditRatingTerm' : '',
						'creditRatingFrom' : '',
						'creditRatingTo' : '',
						'text' : 'Peer Group 1',
						'index' : '1',
						'peerName' : 'Peer Group 1',
						'peerType' : 'INDUSTRY',
						'creditRangeSelected' : [],
						'deleted' : false,
						'selectAllPeer' : 'false',
						'selectAllLoc' : 'false',
						'excludeIssuerCheck':false
					};
				
				$scope.selectedPeerGroups.push($scope.selectedPeerGroupsForPort);

			} else {

				$scope.selectedIndustries=temptab==2 ? 'Financials' : 'Bank';
				$scope.selectedPeerGroupsForPort = {
						'key' : 'PeerGroup1',
						'peerValue' : '',
						'location' : '',
						'salesTurnoverFrom' : '',
						'salesTurnoverTo' : '',
						'salesTurnoverUnit' : '',
						'totalDebtFrom' : '',
						'totalDebtTo' : '',
						'totalDebtUnit' : '',
						'ebitdaMarginFrom' : '',
						'ebitdaMarginTo' : '',
						'creditRatingTerm' : '',
						'creditRatingFrom' : '',
						'creditRatingTo' : '',
						'text' : 'Peer Group 1',
						'index' : '1',
						'peerName' : 'Peer Group 1',
						'peerType' : 'INDUSTRY',
						'creditRangeSelected' : [],
						'deleted' : false,
						'selectAllPeer' : 'false',
						'selectAllLoc' : 'false',
						'excludeIssuerCheck':false,
						'selectedIndustries':$scope.selectedIndustries,
						'parentIndustries':$scope.selectedIndustries
						
					};
				$scope.selectedPeerGroups.push($scope.selectedPeerGroupsForPort);
			}
		/*	vm.alertMessages = [];
			vm.selectedPeerGroupsToBeSaved = [];
			for (var count = 0; count < $scope.selectedPeerGroups.length; count++) {
				if (temptab === 2) {
					if ($rootScope.parentIndustry == "selectAll") {
						vm.alertMessages
								.push("Please select Either Nbfc  or bank for  "
										+ $scope.selectedPeerGroups[count].text);
					}
				}

				if ($scope.selectedPeerGroups[count].peerValue == null
						|| $scope.selectedPeerGroups[count].peerValue == '') {
					vm.alertMessages
							.push("Please select Industry/Product for  "
									+ $scope.selectedPeerGroups[count].text);
				}
				if (temptab == 1) {
					if ($scope.selectedPeerGroups[count].location == null
							|| $scope.selectedPeerGroups[count].location == '') {
						vm.alertMessages.push("Please select location for  "
								+ $scope.selectedPeerGroups[count].text);
					}
					
					//Removed for #107862
					if (!validateFilter(
							$scope.selectedPeerGroups[count].salesTurnoverFrom,
							$scope.selectedPeerGroups[count].salesTurnoverTo)) {

						vm.alertMessages
								.push("Please enter Revenue values within your subscription range for "
										+ $scope.selectedPeerGroups[count].text);
					}

				}
				if (temptab == 2) {

					if (!validateFilter(
							$scope.selectedPeerGroups[count].industryTotalIncomeFrom,
							$scope.selectedPeerGroups[count].industryTotalIncomeTo)) {

						vm.alertMessages
								.push("Please enter industry total income within your subscription range for "
										+ $scope.selectedPeerGroups[count].text);
					}

				}
				if (vm.alertMessages.length > 0) {
					var messages = "";
					for (var count = 0; count < vm.alertMessages.length; count++) {
						messages += vm.alertMessages[count] + "\n"
					}
					$scope.showErrorMessages(vm.alertMessages.toString());
					$scope.filterCriteriaFlag = true;
					return false;
				}

				if (temptab == 1) {

					// Credit rating validation - starts
					var comp = 0;
					var withingRange = false;
					var outOfRange = false;

					while (comp <= vm.rangeToComapare.length - 1) {

						if (vm.rangeToComapare[comp].maxVvalue == 1000000) {
							vm.rangeToComapare[comp].maxVvalue = $scope.upperlimit;
						}

						if (Number($scope.selectedPeerGroups[count].salesTurnoverFrom) >= vm.rangeToComapare[comp].minValue
								&& Number($scope.selectedPeerGroups[count].salesTurnoverTo) <= vm.rangeToComapare[comp].maxVvalue) {
							withingRange = true;
						}

						if ($scope.upperLimitFlag
								&& Number($scope.selectedPeerGroups[count].salesTurnoverTo) > $scope.upperlimit) {
							outOfRange = true;
						}
						comp = comp + 1;

					}

					if (outOfRange) {
						vm.alertMessages
								.push("Please enter Revenue values less than maximum limit mentioned for "
										+ $scope.selectedPeerGroups[count].text);
					}
					if (withingRange != true && !outOfRange) {
						vm.alertMessages
								.push("Please enter Revenue values within your subscription range for "
										+ $scope.selectedPeerGroups[count].text);
					}

					if (Number($scope.selectedPeerGroups[count].salesTurnoverFrom) > Number($scope.selectedPeerGroups[count].salesTurnoverTo)) {
						vm.alertMessages
								.push("Upper limit of Revenue range should be greater than lower limit for "
										+ $scope.selectedPeerGroups[count].text);
					}
					// Credit rating validation - ends

					if (!validateFilterValues(
							$scope.selectedPeerGroups[count].netWorthFrom,
							$scope.selectedPeerGroups[count].netWorthTo)) {

						vm.alertMessages
								.push("Insufficient values for Networth for "
										+ $scope.selectedPeerGroups[count].text);
					}
					if (!validateFilterValues(
							$scope.selectedPeerGroups[count].salesGrowthFrom,
							$scope.selectedPeerGroups[count].salesGrowthTo)) {

						vm.alertMessages
								.push("Insufficient values for Operating Income Growth for "
										+ $scope.selectedPeerGroups[count].text);
					}
				}
				if (!validateFilterValues(
						$scope.selectedPeerGroups[count].totalDebtFrom,
						$scope.selectedPeerGroups[count].totalDebtTo)) {

					vm.alertMessages
							.push("Insufficient values for Total Debt for "
									+ $scope.selectedPeerGroups[count].text);
				}

				if (!validateFilterValues(
						$scope.selectedPeerGroups[count].ebitdaMarginFrom,
						$scope.selectedPeerGroups[count].ebitdaMarginTo)) {

					vm.alertMessages
							.push("Insufficient values for Ebitda Margin for "
									+ $scope.selectedPeerGroups[count].text);
				}

				if (vm.alertMessages.length > 0) {
					var messages = "";
					for (var count = 0; count < vm.alertMessages.length; count++) {
						messages += vm.alertMessages[count] + "\n"
					}
					$scope.showErrorMessages(vm.alertMessages.toString());
					$scope.filterCriteriaFlag = true;
					return false;
				}

				if (($scope.selectedPeerGroups[count].netWorthFrom != '' && $scope.selectedPeerGroups[count].netWorthFrom != null)
						&& Number($scope.selectedPeerGroups[count].netWorthFrom) >= Number($scope.selectedPeerGroups[count].netWorthTo)) {
					vm.alertMessages
							.push("Please select ( Net Worth ) range correctly for  "
									+ $scope.selectedPeerGroups[count].text);
				}

				if (($scope.selectedPeerGroups[count].salesGrowthFrom != '' && $scope.selectedPeerGroups[count].salesGrowthFrom != null)
						&& Number($scope.selectedPeerGroups[count].salesGrowthFrom) >= Number($scope.selectedPeerGroups[count].salesGrowthTo)) {
					vm.alertMessages
							.push("Please select ( Operating Income Growth ) range correctly for  "
									+ $scope.selectedPeerGroups[count].text);
				}

				if (($scope.selectedPeerGroups[count].totalDebtFrom != '' && $scope.selectedPeerGroups[count].totalDebtFrom != null)
						&& Number($scope.selectedPeerGroups[count].totalDebtFrom) >= Number($scope.selectedPeerGroups[count].totalDebtTo)) {
					vm.alertMessages
							.push("Please select ( Total Debt ) range correctly for   "
									+ $scope.selectedPeerGroups[count].text);

				}
				if (temptab == 1) {

					if (($scope.selectedPeerGroups[count].ebitdaMarginFrom != '' && $scope.selectedPeerGroups[count].ebitdaMarginFrom != null)
							&& Number($scope.selectedPeerGroups[count].ebitdaMarginFrom) >= Number($scope.selectedPeerGroups[count].ebitdaMarginTo)) {
						vm.alertMessages
								.push("Please select ( EBITDA Margin ) range correctly for  "
										+ $scope.selectedPeerGroups[count].text);

					}
				}

				if (vm.alertMessages.length > 0) {
					var messages = "";
					for (var count = 0; count < vm.alertMessages.length; count++) {
						messages += vm.alertMessages[count] + "\n"
					}
					$scope.showErrorMessages(vm.alertMessages.toString());
					$scope.filterCriteriaFlag = true;
					return false;
				}

				if (vm.alertMessages.length == 0) {
					if (count == 0) {

						vm.selectedPeerGroupsToBeSaved
								.push($scope.selectedPeerGroups[count]);

					} else if (count == 1) {

						vm.selectedPeerGroupsToBeSaved
								.push($scope.selectedPeerGroups[count]);

					} else if (count == 2) {

						vm.selectedPeerGroupsToBeSaved
								.push($scope.selectedPeerGroups[count]);

					} else if (count == 3) {

						vm.selectedPeerGroupsToBeSaved
								.push($scope.selectedPeerGroups[count]);

					}
				}
			}*///
			return true;

		}

		// Compare peer group - starts
		$scope.resetYearData = function() {
			$scope.cy = null;
			$scope.cy1 = null;
			$scope.cy2 = null;
		}

		$scope.setFinancialType = function(type) {
			if (type == $scope.financialType) {
				// Same radio button selected, so do nothing
				return;
			}
			
			if(type == 'SAMPLE'){
				$scope.financialFilterOption.financialType = type;
				$scope.getYearSelecetedValue();
				if($scope.yearSelected.length > 0){
					$scope.fiveYearList=[];
					$scope.fiveYearList.push($scope.yearSelected[0]);
					$scope.fiveYearList.push($scope.fiveYearList[0] - 1);
					$scope.fiveYearList.push($scope.fiveYearList[0] - 2);
					$scope.fiveYearList.push($scope.fiveYearList[0] - 3);
					$scope.fiveYearList.push($scope.fiveYearList[0] - 4);
				}
				$('#commonYearPopUp').modal('show');
				
			}else{
			$scope.financialFilterOption.financialType = type;
			$scope.fetchCommonDataForFinancials();
			}
		}

		$scope.setNegativeNetworth = function(excludeNegativeNetworth) {
			$scope.financialFilterOption.excludeNegativeNetworth = excludeNegativeNetworth;
			$scope.fetchCommonDataForFinancials();
		}

		$scope.fetchCommonDataForFinancials = function() {
			/*if ($scope.financialFilterOption.financialType == 'YEAR') {
				$scope.resetFinancialParameter();
			}*/    //commented for bug id 61005
			var fd = new FormData();
			var uploadUrl = "";
			$scope.commonYearListdata = "";
			if($scope.financialFilterOption.financialType != 'SAMPLE'){
				
			$scope.getYearSelecetedValue();
//			$scope.cy= $scope.yearSelected[0];
//			$scope.cy1= $scope.yearSelected[1];
//			$scope.cy2= $scope.yearSelected[2];
			
			}
//			else{
//				if ($scope.financialFilterOption.currentYearVal != false) {
//					//$scope.yearSelected.push($scope.cy);
//					$scope.cy=$scope.yearSelected[0];
//				}else{
//					$scope.cy=$scope.yearSelected[0];
//					$scope.yearSelected.splice($scope.yearSelected.indexOf($scope.yearSelected[0]));
//				}
//				if ($scope.financialFilterOption.currentYearMinOneVal != false) {
//					$scope.cy1 = $scope.yearSelected[1];
//					//$scope.yearSelected.push($scope.cy1);
//				}else{
//					$scope.cy1 = $scope.yearSelected[1];
//					$scope.yearSelected.splice($scope.yearSelected.indexOf($scope.yearSelected[1]));
//				}
//				if ($scope.financialFilterOption.currentYearMinTwoVal != false) {
//					$scope.cy2 = $scope.yearSelected[2];
//					//$scope.yearSelected.push($scope.cy2);
//				}else{
//					$scope.cy2 = $scope.yearSelected[2];
//					$scope.yearSelected.splice($scope.yearSelected.indexOf($scope.yearSelected[2]));
//					
//				}
//
//				
//			}
			fd.append('selectedPeerGroups', angular
					.toJson($scope.selectedPeerGroups));
			fd.append('financialType',
					$scope.financialFilterOption.financialType);
			fd.append('excludeNegativeNetworth',
					$scope.financialFilterOption.excludeNegativeNetworth);
			fd.append('portfolioId',
					$scope.portfolioId);

			if ($scope.tabid == 1) {
				fd.append('yearSelected', $scope.yearSelected);
				uploadUrl = 'api/industryBenchmark/getBenchmarkFinancialOutputData';

			} else if ($scope.tabid == 2) {
				formulaFlag = true;
				fd.append('calculationForFlag', formulaFlag);
				fd.append('yearSelected', $scope.yearSelected);
				fd.append('portfolioId',
						$scope.portfolioId);
				uploadUrl = 'api/industryBenchmarkFinacial/getBenchmarkFinancialTabOutputData';
			}
			$http
					.post(uploadUrl, fd, {
						transformRequest : angular.identity,
						headers : {
							'Content-Type' : undefined
						}
					})
					.success(
							function(response, status, headers, config) {
								// Validation for common year across peer groups
								// starts
								if ($scope.financialFilterOption.selectedPeerGroupForFilter.length == 0) {
									for (var count = 0; count < response.peerGroupDtoList.length; count++) {
										$scope.financialFilterOption.selectedPeerGroupForFilter
												.push(response.peerGroupDtoList[count].key);

									}
								}
								var peerGroupYearMap = response.peerGroupWiseYear;
								var peerGroupYearArr = new Array();
								var k = 0;
								for ( var _i in peerGroupYearMap) {
									if (peerGroupYearMap.hasOwnProperty(_i)) {
										var peerGroupYearList = peerGroupYearMap[_i];

										if ($scope.financialFilterOption.selectedPeerGroupForFilter
												.indexOf(_i) > -1) {
											peerGroupYearArr
													.push(peerGroupYearList);
											if (peerGroupYearList.length > 0) {
												year = [];
												year = peerGroupYearList;
												$scope.selectedPeerGroups[k].yearsstr = (peerGroupYearMap[_i])
														.toString();
											}
										}

									}
									k++;
								}
								if (peerGroupYearArr != null
										&& peerGroupYearArr.length >= 0) {

									var commonYearList = peerGroupYearArr
											.shift()
											.filter(
													function(v) {
														return peerGroupYearArr
																.every(function(
																		a) {
																	return a
																			.indexOf(v) !== -1;
																});
													});
									if (commonYearList.length == 0) {
										$scope.financialFilterOption.financialType = 'YEAR';
										$scope
												.showErrorMessages("No common data present for selected peer groups, Please expand your selection criteria");
										return false;
									}

								}
								// for financial tab
								if ($scope.tabid == 1) {

									$scope.commonYearListdata = response.peerGroupDtoList.length;

								} else if ($scope.tabid == 2) {
									$scope.commonYearListdata = response.peerGroupFinDtoList.length;
								}
								// Validation for common year ends
								if (status === 204) {
									vm.entityResponse = response;
									$scope
											.showErrorMessages(vm.entityResponse.description);
									return;
								}

								$scope.compare = true;

								$scope.financialData = response.finanacialRowData;

								$scope.peerGroupWiseYear = response.peerGroupWiseYear;
								$scope.peerGroupWiseYearCount = response.peerGroupWiseYearCount;

								var tempstr = $scope.financialFilterOption.selectedPeerGroupForFilter;
								// To reset financial Parameter --changed for
								// common count issue
								// $scope.resetFinancialParameter();
								$scope.financialFilterOption.selectedPeerGroupForFilter = tempstr;
								/*
								 * for (var count = 0; count <
								 * response.peerGroupDtoList.length; count++) {
								 * $scope.financialFilterOption.selectedPeerGroupForFilter
								 * .push(response.peerGroupDtoList[count].key); }
								 */

								if ($scope.financialFilterOption.selectedPeerGroupForFilter.length == 1) {
									$scope.financialFilterOption.financialPeerMinMaxFlag = 'YES'
								} else {
									$scope.financialFilterOption.financialPeerMinMaxFlag = 'NO'
								}
								// added for common count issue
								if ($scope.financialFilterOption.financialType == 'SAMPLE') {
									if ($scope.commonYearListdata == $scope.financialFilterOption.selectedPeerGroupForFilter.length) {
										var peerGroup1Arr = commonYearList;
									} else {
										var peerGroup1Arr = response.peerGroupWiseYear[$scope.financialFilterOption.selectedPeerGroupForFilter[0]];
									}

								} else {
									if ($scope.commonYearListdata == $scope.financialFilterOption.selectedPeerGroupForFilter.length) {
										var peerGroup1Arr = commonYearList;
									} else {
										var peerGroup1Arr = response.peerGroupWiseYear[$scope.financialFilterOption.selectedPeerGroupForFilter[0]];
									}

								}
								// end

								financialValue = [];

								$scope.currentYear = peerGroup1Arr[0];
								// To show financial tabset data

								if ($scope.tabid == 1) {
									$scope.industryBenchmarkFinancialOutputData = {
										dataProvider : $scope.financialData,
										styles : flexiciousNmsp.UIUtils
												.getThemeById('officeblue').styles,
										delegate : $scope
									};
									$timeout(function() {
										$scope.buildGridFinancialInfo(true);
									}, 100);
								} else if ($scope.tabid == 2) {
									$scope.industryBenchmarkFinancialOutputTabData = {
										dataProvider : $scope.financialData,
										styles : flexiciousNmsp.UIUtils
												.getThemeById('officeblue').styles,
										delegate : $scope
									};
									$timeout(function() {
										$scope.buildGridFinancialTabInfo();
									}, 100)

								}
							})
					.error(
							function(response, status, headers, config) {
								vm.entityResponse = response;
								$scope
										.showErrorMessages(vm.entityResponse.description);

							});
		}

		$scope.financialFilterOption.notCheckedCurrentYearVal = false;
		$scope.financialFilterOption.currentYearVal = false;
		$scope.financialFilterOption.notCheckedCurrentYearMinOneVal = false;
		$scope.financialFilterOption.currentYearMinOneVal = false;
		$scope.financialFilterOption.notCheckedCurrentYearMinTwoVal = false;
		$scope.financialFilterOption.currentYearMinTwoVal = false;
		$scope.proceedComparison = function() {

			// To reset the selected parameters
			$scope.resetBenchmarkOutput();

			for (var count = 0; count < $scope.selectedPeerGroups.length; count++) {
				var selectedPeerGroup = $scope.selectedPeerGroups[count];
				if ($scope.invalidPeerGroupsArr != null
						&& $scope.invalidPeerGroupsArr.length > 0) {
					for (var i = 0; i < $scope.invalidPeerGroupsArr.length; i++) {
						var invalidPeerGroupName = $scope.invalidPeerGroupsArr[i];
						if (invalidPeerGroupName === selectedPeerGroup.text
								.trim()) {
							$scope.selectedPeerGroups.splice(count, 1);
						}
					}
				}
			}
			$('#removePeerGroupFromCalculationsConfirmation').modal('hide');

			if ($scope.selectedPeerGroups.length == 0) {
				$scope
						.showErrorMessages("Insufficient data for selected Peer group(s). Please broaden your selection.");
				return;
			}

			// Operation Parameter condition
			if ($scope.selectedPeerGroups != null
					&& $scope.selectedPeerGroups.length > 1) {
				$scope.disableOperationalParameter = true;
			} else {
				var peerOneIndustries = $scope.selectedPeerGroups[0].peerValue;
				var peerOneIndustriesArray = peerOneIndustries.split(',');
				if (peerOneIndustriesArray != null
						&& peerOneIndustriesArray.length > 1) {
					$scope.disableOperationalParameter = true;
				}
			}

			if ($rootScope.excludeCompanies1 != ""
					|| $rootScope.excludeCompanies2 != ""
					|| $rootScope.excludeCompanies3 != ""
					|| $rootScope.excludeCompanies4 != "") {
				// $scope.showCommonToggle=true;
				$scope.showCommonToggle = false;
				// $scope.financialFilterOption.financialType = 'SAMPLE';
				$scope.financialFilterOption.financialType = 'YEAR';
				// $scope.fetchCommonDataForFinancials();
			} else {
				$scope.financialFilterOption.financialType = 'YEAR';
				$scope.showCommonToggle = false;
			}
			$scope.getYearSelecetedValue();
			var fd = new FormData();
			// alert($scope.financialFilterOption.financialType);
			fd.append('selectedPeerGroups', angular
					.toJson($scope.selectedPeerGroups));
			fd.append('financialType',
					$scope.financialFilterOption.financialType);
			fd.append('excludeNegativeNetworth',
					$scope.financialFilterOption.excludeNegativeNetworth);
			fd.append('disableOperationalParameter',
					$scope.disableOperationalParameter);
			fd.append('portfolioId',
					$scope.portfolioId);

			fd.append('yearSelected', $scope.yearSelected);
			var uploadUrl = 'api/industryBenchmark/getBenchmarkFinancialOutputData';

			$http
					.post(uploadUrl, fd, {
						transformRequest : angular.identity,
						headers : {
							'Content-Type' : undefined
						}
					})
					.success(
							function(response, status, headers, config) {
								// Validation for common year across peer groups
								// starts
								// added for common count issue
								// $scope.selectedpeergroupobj =
								// $scope.selectedPeerGroups;
								var peerGroupYearMap = response.peerGroupWiseYear;
								var peerGroupYearArr = new Array();
								for ( var i in peerGroupYearMap) {
									if (peerGroupYearMap.hasOwnProperty(i)) {
										var peerGroupYearList = peerGroupYearMap[i];
										peerGroupYearArr
												.push(peerGroupYearList);
									}
								}
								var commonYearList = [];
								if (peerGroupYearArr != null
										&& peerGroupYearArr.length >= 0) {

									commonYearList = peerGroupYearArr
											.shift()
											.filter(
													function(v) {
														return peerGroupYearArr
																.every(function(
																		a) {
																	return a
																			.indexOf(v) !== -1;
																});
													});
									if (commonYearList.length == 0) {
										$scope
												.showErrorMessages("No  year present for selected peer groups. Please expand your selection criteria.");
										return false;
									}

								}
								// Validation for common year ends
								if (status === 204) {
									vm.entityResponse = response;
									$scope
											.showErrorMessages(vm.entityResponse.description);
									return;
								}

								$scope.compare = true;
								$scope.cy = null;
								$scope.cy1 = null;
								$scope.cy2 = null;

								$scope.filterCriteriaFlag = false;
								$scope.showResult = true;

								$scope.financialFilterOption.financialType = 'YEAR';
								// To reset financial Parameter
								$scope.resetFinancialParameter();
								// TODO :: Swapnil : Push all peer groups
								for (var count = 0; count < response.peerGroupDtoList.length; count++) {
									$scope.financialFilterOption.selectedPeerGroupForFilter
											.push(response.peerGroupDtoList[count].key);

									for ( var i in $scope.selectedPeerGroups) {
										if ($scope.selectedPeerGroups[i].key == response.peerGroupDtoList[count].key) {
											$scope.selectedPeerGroups[i].yearsstr = (peerGroupYearMap[$scope.selectedPeerGroups[i].key])
													.toString();
										}
									}

								}

								if ($scope.financialFilterOption.selectedPeerGroupForFilter.length == 1) {
									$scope.financialFilterOption.financialPeerMinMaxFlag = 'YES'
								} else {
									$scope.financialFilterOption.financialPeerMinMaxFlag = 'NO'
								}

								$scope.financialData = response.finanacialRowData;

								// $scope.ratingData = response.ratingRowData;
								// $scope.operationalData =
								// response.operationalRowData;

								$scope.peerGroupWiseYear = response.peerGroupWiseYear;
								$scope.peerGroupWiseYearGraph = response.peerGroupWiseYear;
								$scope.peerGroupWiseYearCount = response.peerGroupWiseYearCount;
								for ( var key in $scope.peerGroupWiseYearCount) {
									if ($scope.peerGroupWiseYearCount
											.hasOwnProperty(key)) {
										// $scope.pgs.push(key);
									}
								}
								// TODO :: Swapnil : Show common year for all
								// peer groups
								// var peerGroup1Arr =
								// response.peerGroupWiseYear[$scope.financialFilterOption.selectedPeerGroupForFilter[0]];
								var peerGroup1Arr = commonYearList;

								year = [];
								if (peerGroup1Arr.length >= 1) {
									$scope.cy = peerGroup1Arr[0];
									year.push($scope.cy);
									if(peerGroup1Arr.length == 1){
										$scope.oneYear = true;
									}else{
										$scope.oneYear = false
									}
									// $scope.financialFilterOption.notCheckedCurrentYearVal
									// = true;
									// $scope.financialFilterOption.currentYearVal
									// = true;
									$scope.financialFilterOption.notCheckedCurrentYearVal = true;
									$scope.financialFilterOption.currentYearVal = true;
								}
								if (peerGroup1Arr.length >= 2) {
									$scope.cy1 = peerGroup1Arr[1];
									year.push($scope.cy1);
									// $scope.financialFilterOption.notCheckedCurrentYearMinOneVal
									// = true;
									// $scope.financialFilterOption.currentYearMinOneVal
									// = true;
									$scope.financialFilterOption.notCheckedCurrentYearMinOneVal = true;
									$scope.financialFilterOption.currentYearMinOneVal = true;
									$scope.financialFilterOption.notCheckedCurrentYearMinTwoVal = false;
									$scope.financialFilterOption.currentYearMinTwoVal = false;
								}
								if (peerGroup1Arr.length >= 3) {
									$scope.cy2 = peerGroup1Arr[2];
									year.push($scope.cy2);
									// $scope.financialFilterOption.notCheckedCurrentYearMinTwoVal
									// = true;
									// $scope.financialFilterOption.currentYearMinTwoVal
									// = true;	
									$scope.financialFilterOption.notCheckedCurrentYearMinTwoVal = true;
									$scope.financialFilterOption.currentYearMinTwoVal = true;
								}

								// TODO :: Swapnil : Add year depending upon the
								// peer groups selected
								$scope.currentYear = peerGroup1Arr[0];

								if ($scope.financialData == null) {
									$scope
											.showErrorMessages("No data for given selection. Please change/expand your selection.");
									$scope.modifyPeerGroup();
								}
								// To show financial tabset
								$scope.activeOutputForm = 1;
								// To show financial tabset data
								$scope.industryBenchmarkFinancialOutputData = {
									dataProvider : $scope.financialData,
									styles : flexiciousNmsp.UIUtils
											.getThemeById('officeblue').styles,
									delegate : $scope
								};
								$timeout(function() {
									$scope.buildGridFinancialInfo();
								}, 100);
								$scope.filterCriteriaFlag = false;
								$scope.showResult = true;

							})
					.error(
							function(response, status, headers, config) {
								vm.entityResponse = response;
								$scope
										.showErrorMessages(vm.entityResponse.description);

							});

		}

		$scope.proceedComparisonForFinancial = function() {

			// To reset the selected parameters
			$scope.resetBenchmarkOutput();

			var fd = new FormData();
			formulaFlag = true;
			fd.append('calculationForFlag', formulaFlag);
			fd.append('selectedPeerGroups', angular
					.toJson($scope.selectedPeerGroups));
			fd.append('financialType',
					$scope.financialFilterOption.financialType);
			fd.append('excludeNegativeNetworth',
					$scope.financialFilterOption.excludeNegativeNetworth);
			fd.append('disableOperationalParameter',
					$scope.disableOperationalParameter);
			fd.append('yearSelected', $scope.yearSelected);
			fd.append('portfolioId',
					$scope.portfolioId);
			var uploadUrl = 'api/industryBenchmarkFinacial/getBenchmarkFinancialTabOutputData';

			$http
					.post(uploadUrl, fd, {
						transformRequest : angular.identity,
						headers : {
							'Content-Type' : undefined
						}
					})
					.success(
							function(response, status, headers, config) {

								var peerGroupYearMap = response.peerGroupWiseYear;
								var peerGroupYearArr = new Array();
								for ( var i in peerGroupYearMap) {
									if (peerGroupYearMap.hasOwnProperty(i)) {
										var peerGroupYearList = peerGroupYearMap[i];
										peerGroupYearArr
												.push(peerGroupYearList);
									}
								}
								var commonYearList = [];
								if (peerGroupYearArr != null
										&& peerGroupYearArr.length >= 0) {

									commonYearList = peerGroupYearArr
											.shift()
											.filter(
													function(v) {
														return peerGroupYearArr
																.every(function(
																		a) {
																	return a
																			.indexOf(v) !== -1;
																});
													});
									if (commonYearList.length == 0) {
										$scope
												.showErrorMessages("No  year present for selected peer groups. Please expand your selection criteria.");
										return false;
									}

								}
								// Validation for common year ends
								if (status === 204) {
									vm.entityResponse = response;
									$scope
											.showErrorMessages(vm.entityResponse.description);
									return;
								}

								$scope.compare = true;
								$scope.cy = null;
								$scope.cy1 = null;
								$scope.cy2 = null;

								$scope.filterCriteriaFlag = false;
								$scope.showResult = true;

								$scope.financialFilterOption.financialType = 'YEAR';
								$scope.resetFinancialParameter();
								for (var count = 0; count < response.peerGroupFinDtoList.length; count++) {
									$scope.financialFilterOption.selectedPeerGroupForFilter
											.push(response.peerGroupFinDtoList[count].key);

									for ( var i in $scope.selectedPeerGroups) {
										if ($scope.selectedPeerGroups[i].key == response.peerGroupFinDtoList[count].key) {
											$scope.selectedPeerGroups[i].yearsstr = (peerGroupYearMap[$scope.selectedPeerGroups[i].key])
													.toString();
										}
									}

								}

								if ($scope.financialFilterOption.selectedPeerGroupForFilter.length == 1) {
									$scope.financialFilterOption.financialPeerMinMaxFlag = 'YES'
								} else {
									$scope.financialFilterOption.financialPeerMinMaxFlag = 'NO'
								}

								$scope.financialTabData = response.finanacialRowData;

								$scope.peerGroupWiseYear = response.peerGroupWiseYear;
								$scope.peerGroupWiseYearGraph = response.peerGroupWiseYear;
								$scope.peerGroupWiseYearCount = response.peerGroupWiseYearCount;
								for ( var key in $scope.peerGroupWiseYearCount) {
									if ($scope.peerGroupWiseYearCount
											.hasOwnProperty(key)) {

									}
								}

								var peerGroup1Arr = commonYearList;
								year = [];
								if (peerGroup1Arr.length >= 1) {
									$scope.cy = peerGroup1Arr[0];
									year.push($scope.cy);
									$scope.financialFilterOption.notCheckedCurrentYearVal = true;
									$scope.financialFilterOption.currentYearVal = true;
								}
								if (peerGroup1Arr.length >= 2) {
									$scope.cy1 = peerGroup1Arr[1];
									year.push($scope.cy1);
									$scope.financialFilterOption.notCheckedCurrentYearMinOneVal = true;
									$scope.financialFilterOption.currentYearMinOneVal = true;
									$scope.financialFilterOption.notCheckedCurrentYearMinTwoVal = false;
									$scope.financialFilterOption.currentYearMinTwoVal = false;
								}
								if (peerGroup1Arr.length >= 3) {
									$scope.cy2 = peerGroup1Arr[2];
									year.push($scope.cy2);
									$scope.financialFilterOption.notCheckedCurrentYearMinTwoVal = true;
									$scope.financialFilterOption.currentYearMinTwoVal = true;
								}

								$scope.currentYear = peerGroup1Arr[0];

								if ($scope.financialTabData == null) {
									$scope
											.showErrorMessages("No data for given selection. Please change/expand your selection.");
									$scope.modifyPeerGroup();
								}

								$scope.activeOutputForm = 1;
								$scope.industryBenchmarkFinancialOutputTabData = {
									dataProvider : $scope.financialTabData,
									styles : flexiciousNmsp.UIUtils
											.getThemeById('officeblue').styles,
									delegate : $scope
								};
								$timeout(function() {
									$scope.buildGridFinancialTabInfo();
								}, 100)

								$scope.filterCriteriaFlag = false;
								$scope.showResult = true;
								$scope.financialTabData = response.finanacialRowData;

							})

					.error(
							function(response, status, headers, config) {
								vm.entityResponse = response;
								$scope
										.showErrorMessages(vm.entityResponse.description);

							});

		}

		// Remove invalid peer group

		$scope.proceedComparisonForTab = function(tapId) {
			if (tapId == 1) {
				$scope.proceedComparison();

			} else if (tapId == 2) {
				$scope.proceedComparisonForFinancial();

			}
		}

		// Get rating data
		$scope.fetchRatingData = function() {
			var fd = new FormData();
			fd.append('selectedPeerGroups', angular
					.toJson($scope.selectedPeerGroups));
			fd.append('financialType',
					$scope.financialFilterOption.financialType);
			fd.append('excludeNegativeNetworth',
					$scope.financialFilterOption.excludeNegativeNetworth);
			var uploadUrl = 'api/industryBenchmark/getBenchmarkRatingOutputData';
			$http.post(uploadUrl, fd, {
				transformRequest : angular.identity,
				headers : {
					'Content-Type' : undefined
				},
				ignoreLoadingBar : false
			}).success(
					function(response, status, headers, config) {

						$scope.ratingData = response.ratingRowData;

						// To show financial tabset data
						$scope.industryBenchmarkRatingOutputData = {
							dataProvider : $scope.ratingData,
							styles : flexiciousNmsp.UIUtils
									.getThemeById('officeblue').styles,
							delegate : $scope
						};
						$timeout(function() {
							$scope.buildGridRatingInfo();
						}, 100);
					}).error(function(response, status, headers, config) {
				vm.entityResponse = response;
				$scope.showErrorMessages(vm.entityResponse.description);

			});
		}

		// Get Operational data
		$scope.fetchOperationalData = function() {
			// To reset operational years
			yearForOperational = [];
			$scope.getYearSelecetedValue();

			var fd = new FormData();
			fd.append('selectedPeerGroups', angular
					.toJson($scope.selectedPeerGroups));
			fd.append('financialType',
					$scope.financialFilterOption.financialType);
			fd.append('excludeNegativeNetworth',
					$scope.financialFilterOption.excludeNegativeNetworth);

			fd.append('yearSelected', $scope.yearSelected);
			var uploadUrl = 'api/industryBenchmark/getBenchmarkOperationalOutputData';
			$http
					.post(uploadUrl, fd, {
						transformRequest : angular.identity,
						headers : {
							'Content-Type' : undefined
						}
					})
					.success(
							function(response, status, headers, config) {
								$scope.operationalData = response.operationalRowData;
								if ($scope.operationalData != null
										&& $scope.operationalData.length >= 2
										&& $scope.operationalData[1] != null) {
									$scope.currentYearOperationalData = $scope.operationalData[1].currentYear;
									yearForOperational
											.push($scope.currentYearOperationalData);
								}

								// To show financial tabset data
								if ($scope.operationalData != null
										&& $scope.operationalData.length > 0) {
									$scope.industryBenchmarkOperationalOutputData = {
										dataProvider : $scope.operationalData,
										styles : flexiciousNmsp.UIUtils
												.getThemeById('officeblue').styles,
										delegate : $scope
									};
									$timeout(function() {
										$scope.buildGridOperationalInfo();
									}, 100);
								} else {
									$scope.operationEmptyDataFlag = true;
								}
							})
					.error(
							function(response, status, headers, config) {
								vm.entityResponse = response;
								$scope
										.showErrorMessages(vm.entityResponse.description);
							});
		}

		// show graphical data
		$scope.loadgraph = false;
		$scope.loadgraphForFin = false;

		$scope.fetchFinancialDataGraph = function(activeTab) {
			if (activeTab == 1) {
				$scope.loadgraph = true;
				$scope.loadgraphForFin = false;
			} else if (activeTab == 2) {
				$scope.loadgraphForFin = true;
				$scope.loadgraph = false;
			}
		}

		// show tabset data
		$scope.setTabSetData = function(tabsetId, activeTab) {
			$scope.activeOutputForm = tabsetId;
			if (tabsetId == 1) {
				if ($rootScope.excludeCompanies1 != ""
						|| $rootScope.excludeCompanies2 != ""
						|| $rootScope.excludeCompanies3 != ""
						|| $rootScope.excludeCompanies4 != "") {
					// changed this for common count issue true to false
					$scope.showCommonToggle = false;
					// changed this for common count issue
					// $scope.financialFilterOption.financialType = 'SAMPLE';
					$scope.financialFilterOption.financialType = 'YEAR';
				}

				if ($scope.financialData == null) {
					$scope.fetchCommonDataForFinancials();
				}

			} else if (tabsetId == 2) {
				if ($scope.selectedPeerGroups.length == 4) {
					$("#industryBenchmarkRatingOutputContainer").css({
						'width' : '100%'
					});
				} else if ($scope.selectedPeerGroups.length == 3) {
					$("#industryBenchmarkRatingOutputContainer").css({
						'width' : '90%'
					});
				} else if ($scope.selectedPeerGroups.length == 2) {
					$("#industryBenchmarkRatingOutputContainer").css({
						'width' : '70%'
					});
				} else if ($scope.selectedPeerGroups.length == 1) {
					$("#industryBenchmarkRatingOutputContainer").css({
						'width' : '50%'
					});
				}

				if ($scope.ratingData == null) {
					if ($scope.temptab == 1) {
						$scope.fetchRatingData();
					} else if ($scope.temptab == 2) {

						$scope.fetchRatingFinData();

					}
				}

			} else if (tabsetId == 3) {
				if (!$scope.disableOperationalParameter) {

					if ($scope.operationalData == null) {
						$scope.fetchOperationalData();
					}

				}
			} else if (tabsetId == 4) {

				$scope.fetchFinancialDataGraph(activeTab);
			}
		}

		$scope.dynamicColumnsGridForIndustryBenchmarkRatingInfo = function(evt) {

			ratingGrid = evt.target;
			$scope.buildGridRatingInfo();
		};

		$scope.dynamicColumnsGridForIndustryBenchmarkFinancialInfo = function(
				evt) {
			financialGrid = evt.target;
			$scope.buildGridFinancialInfo();
		};

		$scope.dynamicColumnsGridForIndustryBenchmarkFinancialTabInfo = function(
				evt) {
			financialTabGrid = evt.target;
			$scope.buildGridFinancialTabInfo();
		};

		$scope.dynamicColumnsGridForIndustryBenchmarkOperationalInfo = function(
				evt) {

			operationalGrid = evt.target;
			$scope.buildGridOperationalInfo();
		};

		$scope.cancelRemovePeerGroupFromCalculation = function() {
			$('#removePeerGroupFromCalculationsConfirmation').modal('hide');
			// added for cancel button issue
			$scope.invalidPeerGroupsArr = [];
			$scope.status = false;
		}

		$scope.comparePeerGroups = function(temptab) {
			$rootScope.excludeCompanies1 = "";
			$rootScope.excludeCompanies2 = "";
			$rootScope.excludeCompanies3 = "";	
			$rootScope.excludeCompanies4 = "";	
			if ($rootScope.excludeCompanies1 != "" 
					|| $rootScope.excludeCompanies2 != ""
					|| $rootScope.excludeCompanies3 != ""
					|| $rootScope.excludeCompanies4 != "") {
				// changes for common year compnay count true to false
				$scope.showCommonToggle = false;
				// $scope.financialFilterOption.financialType =
				// 'SAMPLE';//changes for common year compnay count
				$scope.financialFilterOption.financialType = 'YEAR';
				$scope.fetchCommonDataForFinancials();
			}

			else {
				$scope.financialFilterOption.financialType = 'YEAR';
				$scope.showCommonToggle = false;
			}

			$scope.selectedPeerGroups = new Array();

			if (!$scope.validateData(temptab)) {
				// alert("Invalid data");
				// return;
			} else {

				$scope.finTab = false;
				$scope.nonFinTab = false;
				$scope.getYearSelecetedValue();
				
				$scope.selectedPeerGroupsTest=$scope.selectedPeerGroups;

				var uploadUrl = "";
				var fd = new FormData();
				fd.append('selectedPeerGroups', angular
						.toJson($scope.selectedPeerGroups));
				fd.append('financialType',
						$scope.financialFilterOption.financialType);
				fd.append('excludeNegativeNetworth',
						$scope.financialFilterOption.excludeNegativeNetworth);
				fd.append('portfolioId',
						$scope.portfolioId);

				if (temptab == 1) {
					$scope.nonFinTab = true;
					$scope.showRatingTab = true;
					fd.append('yearSelected', $scope.yearSelected);
					uploadUrl = 'api/industryBenchmark/validateBenchmarkOutputData';

				} else if (temptab == 2 || temptab == 3) {
					$scope.finTab = true;
					$scope.showRatingTab = false;
					uploadUrl = 'api/industryBenchmarkFinancial/validateBenchmarkOutputData';
				}
				$http
						.post(uploadUrl, fd, {
							transformRequest : angular.identity,
							headers : {
								'Content-Type' : undefined
							}
						})
						.success(
								function(response, status, headers, config) {
									if (response != null && response.length > 0) {

										$scope.invalidPeerGroups = "";
										$scope.invalidPeerGroupsArr = [];
										for (var count = 0; count < response.length; count++) {
											if ($scope.invalidPeerGroups != null
													&& $scope.invalidPeerGroups.length > 0) {
												$scope.invalidPeerGroups = $scope.invalidPeerGroups
														+ ", "
														+ response[count];
											} else {
												$scope.invalidPeerGroups = response[count];
											}
											$scope.invalidPeerGroupsArr
													.push(response[count]);
										}
										$(
												'#removePeerGroupFromCalculationsConfirmation')
												.modal('show');

									} else if ($scope.finTab) {
										$scope.showResult = true;
										$scope.filterCriteriaFlag = false;
										$scope.proceedComparisonForFinancial();
										return true;
									}

									else if ($scope.nonFinTab) {
										$scope.selectedPeerGroups=$scope.selectedPeerGroupsTest;
										$scope.proceedComparison();
									}
								})
						.error(
								function(response, status, headers, config) {
									vm.entityResponse = response;
									$scope
											.showErrorMessages(vm.entityResponse.description);

								});
			}
		}
		
		

		$scope.buildGridRatingInfo = function() {
			var gridCgs = [];
			var ycgmain = new flexiciousNmsp.FlexDataGridColumnGroup();
			gridCgs.push(ycgmain);
			var allheadCols = [];
			var mCol = new flexiciousNmsp.FlexDataGridColumn();
			mCol.setHeaderText("Parameters");
			mCol.setDataField("parameter");
			mCol.headerAlign = "center";
			mCol.setColumnWidthMode("fixed");
			mCol.setWidth(400);
			mCol.sortable = false;
			allheadCols.push(mCol);

			for (var i = 0; i < $scope.selectedPeerGroups.length; i++) {
				var mCols = new flexiciousNmsp.FlexDataGridColumn();
				// mCols.setHeaderText("PeerGroup" + (i + 1));
				// mCols.setDataField("peerGroup" + (i + 1));
				var headerText = $scope.selectedPeerGroups[i].text;
				mCols.setHeaderText(headerText);
				var dataFieldText = "peerGroup"
						+ headerText.substring(headerText.length - 1,
								headerText.length);
				mCols.setDataField(dataFieldText);
				mCols.headerAlign = "center";
				mCols.setStyle("textAlign", "right");
				// mCols.setColumnWidthMode("fitToContent");
				mCols.sortable = false;
				allheadCols.push(mCols);
			}

			ycgmain.setColumns(allheadCols);
			ratingGrid.getColumnLevel().setGroupedColumns(gridCgs);
			ratingGrid.rebuild();
			ratingGrid.validateNow();
		}

		$scope.buildGridOperationalInfo = function() {
			var gridCgs = [];
			var ycgmain = new flexiciousNmsp.FlexDataGridColumnGroup();
			gridCgs.push(ycgmain);
			var allheadCols = [];
			var mCol = new flexiciousNmsp.FlexDataGridColumn();
			mCol.setHeaderText("Parameters");
			mCol.setDataField("parameter");
			mCol.headerAlign = "center";
			mCol.setColumnWidthMode("fixed");
			mCol.setWidth(550);
			mCol.sortable = false;
			mCol.headerHorizontalGridLineColor = "0x000000";
			mCol.columnGroupHorizontalGridLineColor = "0x000000";
			allheadCols.push(mCol);

			var mCol1 = new flexiciousNmsp.FlexDataGridColumn();
			mCol1.setHeaderText("Units");
			mCol1.setDataField("unit");
			mCol1.headerAlign = "center";
			mCol1.setColumnWidthMode("fitToContent");
			mCol1.sortable = false;
			mCol1.headerHorizontalGridLineColor = "0x000000";
			mCol1.columnGroupHorizontalGridLineColor = "0x000000";

			allheadCols.push(mCol1);
			ycgmain.setColumns(allheadCols);

			for (var p = 0; p < $scope.selectedPeerGroups.length; p++) {
				var ycg = new flexiciousNmsp.FlexDataGridColumnGroup();
				gridCgs.push(ycg);
				// ycg.setHeaderText("PeerGroup" + (p + 1));
				ycg.setHeaderText($scope.selectedPeerGroups[p].text);
				// var dataFieldForfinancialVal = 'PeerGroup' + (p + 1);
				var dataFieldForfinancialVal = $scope.selectedPeerGroups[p].key;

				var colSubHeader = [];
				for (var k = 0; k < yearForOperational.length; k++) {
					yearColForOperational = [ yearForOperational[k] ];
					var allCols = [];
					for (var j = 0; j < yearColForOperational.length; j++) {

						var yearColGrid = new flexiciousNmsp.FlexDataGridColumnGroup();
						yearColGrid.setHeaderText(yearColForOperational[j]);

						yearColGrid.setStyle("textAlign", "right");
						yearColGrid.headerAlign = "center";
						yearColGrid.columnWidthMode = "fitToContent";
						colSubHeader.push(yearColGrid);
						operationalValue = [ 'Median', 'Min', 'Max' ];
						operationlCol = operationalValue;

						for (var m = 0; m < operationalValue.length; m++) {

							var optValCol = new flexiciousNmsp.FlexDataGridColumn();
							optValCol.setHeaderText(operationalValue[m]);

							var dataFieldCombined = "";
							var dataFieldForYear = "";

							if (operationlCol[m] == "Median") {
								dataFieldCombined = "median";
							} else if (operationlCol[m] == "Min") {
								dataFieldCombined = "minimum";
							} else if (operationlCol[m] == "Max") {
								dataFieldCombined = "maximum";
							}
							/*
							 * if (yearColForOperational[j] ==
							 * $scope.financialFilterOption.currentYearOperationalData) {
							 * dataFieldForYear = "CurrentYear"; }
							 */
							dataFieldForYear = "CurrentYear";
							optValCol.setDataField(dataFieldCombined
									+ dataFieldForfinancialVal
									+ dataFieldForYear);
							optValCol.sortable = false;
							optValCol.setStyle("textAlign", "right");
							optValCol.headerAlign = "center";
							optValCol.columnWidthMode = "fitToContent";
							optValCol.columnGroupHorizontalGridLineColor = "0x000000";
							allCols.push(optValCol);

						}
						yearColGrid.setColumns(allCols);
					}
				}
				ycg.setGroupedColumns(colSubHeader);
			}
			operationalGrid.getColumnLevel().setGroupedColumns(gridCgs);
			operationalGrid.rebuild();
			operationalGrid.validateNow();
		}

		$scope.rowbackfunction = function(cell) {

			if (cell.rowInfo.getData().parameter.indexOf("<b>") >= 0) {

				return [ 0xcbdfde, 0xcbdfde ]
			} else {
				// return [ 0xcffffde, 0xcbeee]
				// return [0xffffff , 0xffffff ]
			}
			// return null;

		};

		$scope.buildGridYear = function(checkVal, val, tempId) {
			$scope.flagToCheckYearSelectedOrNot = CheckedYearSelected();
			if (tempId === 1) {
				if ($scope.cy == val && checkVal == false) {
					$scope.financialFilterOption.financialType!='YEAR' ? $scope.yearSelected.splice($scope.yearSelected.indexOf($scope.cy)) : '';
					$scope.financialFilterOption.notCheckedCurrentYearVal = checkVal;
				}else if($scope.financialFilterOption.financialType!='YEAR'){
					
					$scope.yearSelected.indexOf($scope.cy) == -1 ?  $scope.yearSelected.push($scope.cy) : '';
				}
				
				if ($scope.cy1 == val && checkVal == false) {
					$scope.financialFilterOption.financialType!='YEAR' ? $scope.yearSelected.splice($scope.yearSelected.indexOf($scope.cy1)) :'';
					$scope.financialFilterOption.notCheckedCurrentYearMinOneVal = checkVal;

				}else if($scope.financialFilterOption.financialType!='YEAR'){
					
					$scope.yearSelected.indexOf($scope.cy1) == -1 ?  $scope.yearSelected.push($scope.cy1) : '';
				}
				
				if ($scope.cy2 == val && checkVal == false) {
					$scope.financialFilterOption.financialType!='YEAR' ? $scope.yearSelected.splice($scope.yearSelected.indexOf($scope.cy2)) : '';
							
					$scope.financialFilterOption.notCheckedCurrentYearMinTwoVal = checkVal;
					
				}else if($scope.financialFilterOption.financialType!='YEAR'){
					
					$scope.yearSelected.indexOf($scope.cy2) == -1 ?  $scope.yearSelected.push($scope.cy2) : '';
				}
				if ($scope.financialFilterOption.financialType == 'YEAR') { 
					$scope.buildGridFinancialInfo(checkVal, val);
				} else {
					$scope.fetchCommonDataForFinancials();
				}
			}

			else if (tempId === 2) {

				$scope.buildGridFinancialTabInfo(checkVal, val);
			}
		}

		// checking Atleast one year selected or not
		
		function CheckedYearSelected(){
			
			if($scope.financialFilterOption.currentYearVal == true && $scope.financialFilterOption.currentYearMinOneVal == false && $scope.financialFilterOption.currentYearMinTwoVal == false){
				$scope.oneYear = true;
				$scope.twoYear = false;
				$scope.threeYear = false;
				return true;
			}else if($scope.financialFilterOption.currentYearVal == true && $scope.financialFilterOption.currentYearMinOneVal == true && $scope.financialFilterOption.currentYearMinTwoVal == false) {
				$scope.oneYear = false;
				$scope.twoYear = false;
				$scope.threeYear = false;
				return true;
			}else if($scope.financialFilterOption.currentYearVal == false && $scope.financialFilterOption.currentYearMinOneVal == true && $scope.financialFilterOption.currentYearMinTwoVal == false){
				$scope.twoYear = true;
				$scope.oneYear = false;
				$scope.threeYear = false;
				return true;
			}else if($scope.financialFilterOption.currentYearVal == false && $scope.financialFilterOption.currentYearMinOneVal == true && $scope.financialFilterOption.currentYearMinTwoVal == true){
				
					$scope.oneYear = false;
					$scope.twoYear = false;
					$scope.threeYear = false;
					return true;
				
			}else if($scope.financialFilterOption.currentYearVal == false && $scope.financialFilterOption.currentYearMinOneVal == false && $scope.financialFilterOption.currentYearMinTwoVal == true){
				$scope.twoYear = false;
				$scope.oneYear = false;
				$scope.threeYear = true;
				return true;
			}else if($scope.financialFilterOption.currentYearVal == true && $scope.financialFilterOption.currentYearMinOneVal == false && $scope.financialFilterOption.currentYearMinTwoVal == true){
				$scope.oneYear = false;
				$scope.twoYear = false;
				$scope.threeYear = false;
				return true;
			}
			
			return true;
		}
		$scope.buildGridOutputValues = function(tempId) {

			if (tempId === 1) {

				$scope.buildGridFinancialInfo();
			}

			else if (tempId === 2) {

				$scope.buildGridFinancialTabInfo();
			}
		}
		$scope.buildGridFinancialInfo = function(checkVal, val) {

			financialValue = [];
			if ($scope.financialFilterOption.medianAggFlag != null
					&& $scope.financialFilterOption.medianAggFlag == 'median') {
				financialValue.push('Median');
			} else if ($scope.financialFilterOption.medianAggFlag != null
					&& $scope.financialFilterOption.medianAggFlag == 'aggregate') {
				financialValue.push('Aggregate');
			}

			if ($scope.financialFilterOption.financialPeerMinMaxFlag != null
					&& $scope.financialFilterOption.financialPeerMinMaxFlag == 'YES') {
				// If only one peer group is selected, only then show min and
				// max.
				if ($scope.financialFilterOption.selectedPeerGroupForFilter.length == 1) {
					financialValue.push('Max');
					financialValue.push('Min');
				} else {
					$scope.financialFilterOption.financialPeerMinMaxFlag = 'NO';
				}
			}

			if (checkVal == true && val == $scope.cy) {
				year.push(val);
			} else if ((checkVal == undefined || checkVal == false)
					&& val == $scope.cy) {
				var i = year.indexOf($scope.cy);
				year.splice(i, 1);
			}
			if (checkVal == true && val == $scope.cy1) {
				year.push(val);
			} else if (checkVal == false && val == $scope.cy1) {
				var i = year.indexOf($scope.cy1);
				year.splice(i, 1);
			}
			if (checkVal == true && val == $scope.cy2) {
				year.push(val);
			} else if (checkVal == false && val == $scope.cy2) {
				var i = year.indexOf($scope.cy2);
				year.splice(i, 1);
			}

			// added for year issue in output
			year.sort(function(a, b) {
				return b - a
			});

			peerGroupsForFinancial = [];
			for (var peer = 0; peer < $scope.financialFilterOption.selectedPeerGroupForFilter.length; peer++) {
				peerGroupsForFinancial
						.push($scope.financialFilterOption.selectedPeerGroupForFilter[peer]);

				if (checkVal == true && val == 'peerGroups') {
					if (peer == $scope.financialFilterOption.selectedPeerGroupForFilter.length - 1) {
						var validCommonYear = $scope.updateCommonYear();

						if (!validCommonYear) {
							return;
						}
					}
				}
			}

			peerGroupsForFinancial = peerGroupsForFinancial.sort();

			var gridCgs = [];
			var ycgmain = new flexiciousNmsp.FlexDataGridColumnGroup();
			gridCgs.push(ycgmain);
			var allheadCols = [];
			var mCol = new flexiciousNmsp.FlexDataGridColumn();
			mCol.setHeaderText("Parameters");
			mCol.setDataField("parameter");
			mCol.headerAlign = "center";
			mCol.setColumnWidthMode("fitToContent");
			mCol.sortable = false;
			mCol.headerWordWrap = true;
			mCol.enableHierarchicalNestIndent = true;
			mCol.headerHorizontalGridLineColor = "0x000000";
			mCol.columnGroupHorizontalGridLineColor = "0x000000";

			allheadCols.push(mCol);

			ycgmain.setColumns(allheadCols);

			for (var p = 0; p < peerGroupsForFinancial.length; p++) {

				var ycg = new flexiciousNmsp.FlexDataGridColumnGroup();
				gridCgs.push(ycg);
				ycg.setHeaderText($scope
						.replacePeerGroupName(peerGroupsForFinancial[p]));
				peerCol = [ peerGroupsForFinancial[p] + "" ];
				var colSubHeader = [];
				for (var k = 0; k < year.length; k++) {
					yearCol = [ year[k] ];
					var allCols = [];
					for (var j = 0; j < yearCol.length; j++) {

						var yearColGrid = new flexiciousNmsp.FlexDataGridColumnGroup();
						// $scope.getPeerGroupYearCount(peerGroupsForFinancial[p],yearCol[j]);
						yearColGrid.setHeaderText(yearCol[j]
								+ $scope.getPeerGroupYearCount(
										peerGroupsForFinancial[p], yearCol[j]));
						yearColGrid.setStyle("textAlign", "right");
						yearColGrid.headerAlign = "center";
						yearColGrid.columnWidthMode = "fitToContent";
						yearColGrid.headerHorizontalGridLineColor = "0x000000";
						colSubHeader.push(yearColGrid);
						col = financialValue;

						for (var m = 0; m < financialValue.length; m++) {

							var financialValCol = new flexiciousNmsp.FlexDataGridColumn();
							if (financialValue.length == 1) {
								financialValCol.setHeaderText(yearCol
										+ $scope.getPeerGroupYearCount(
												peerGroupsForFinancial[p],
												yearCol) + " - "
										+ financialValue[m]);
							} else {
								financialValCol
										.setHeaderText(financialValue[m]);
							}

							var dataFieldCombined = "";
							var dataFieldForYear = "";
							var dataFieldForfinancialVal = '';
							if (col[m] == "Median") {
								dataFieldCombined = "median";
							} else if (col[m] == "Aggregate") {
								dataFieldCombined = "aggregate";
							} else if (col[m] == "Min") {
								dataFieldCombined = "minimum";
							} else if (col[m] == "Max") {
								dataFieldCombined = "maximum";
							}
							var index = -1;
							if (peerGroupsForFinancial[p] == 'PeerGroup1') {
								dataFieldForfinancialVal = "PeerGroup1";
								var peerGroup1Arr = $scope.peerGroupWiseYear['PeerGroup1'];
								index = peerGroup1Arr.indexOf(yearCol[j]);

							} else if (peerGroupsForFinancial[p] == 'PeerGroup2') {
								dataFieldForfinancialVal = "PeerGroup2";
								var peerGroup2Arr = $scope.peerGroupWiseYear['PeerGroup2'];
								index = peerGroup2Arr.indexOf(yearCol[j]);

							} else if (peerGroupsForFinancial[p] == 'PeerGroup3') {
								dataFieldForfinancialVal = "PeerGroup3";
								var peerGroup3Arr = $scope.peerGroupWiseYear['PeerGroup3'];
								index = peerGroup3Arr.indexOf(yearCol[j]);

							} else if (peerGroupsForFinancial[p] == 'PeerGroup4') {
								dataFieldForfinancialVal = "PeerGroup4";
								var peerGroup4Arr = $scope.peerGroupWiseYear['PeerGroup4'];
								index = peerGroup4Arr.indexOf(yearCol[j]);
							}

							if (index == 0) {
								dataFieldForYear = "CurrentYear";

							} else if (index == 1) {
								dataFieldForYear = "CurrentYearMinOne";

							} else if (index == 2) {
								dataFieldForYear = "CurrentYearMinTwo";

							}

							financialValCol.setDataField(dataFieldCombined
									+ dataFieldForfinancialVal
									+ dataFieldForYear);
							financialValCol.sortable = false;
							financialValCol.setStyle("textAlign", "right");
							financialValCol.headerAlign = "center";
							financialValCol.headerWordWrap = "true"
							financialValCol.columnWidthMode = "fitToContent";
							financialValCol.headerHorizontalGridLineColor = "0x000000";
							financialValCol.columnGroupHorizontalGridLineColor = "0x000000";
							financialValCol
									.setLabelFunction($scope.largeDynamicGrid_dataGridFormatNumberLabelFunction);
							allCols.push(financialValCol);

						}
						yearColGrid.setColumns(allCols);
					}

				}
				$scope.year = year;
				ycg.setGroupedColumns(colSubHeader);
			}
			financialGrid.getColumnLevel().setGroupedColumns(gridCgs);
			colCount = financialGrid._columnLevel._columns.length - 1;

			financialGrid.rebuild();
			financialGrid.validateNow();

		}

		$scope.buildGridFinancialTabInfo = function(checkVal, val) {

			financialTabValue = [];
			if ($scope.financialFilterOption.medianAggFlag != null
					&& $scope.financialFilterOption.medianAggFlag == 'median') {
				financialTabValue.push('Median');
			} else if ($scope.financialFilterOption.medianAggFlag != null
					&& $scope.financialFilterOption.medianAggFlag == 'aggregate') {
				financialTabValue.push('Aggregate');
			}

			if ($scope.financialFilterOption.financialPeerMinMaxFlag != null
					&& $scope.financialFilterOption.financialPeerMinMaxFlag == 'YES') {
				// If only one peer group is selected, only then show min and
				// max.
				if ($scope.financialFilterOption.selectedPeerGroupForFilter.length == 1) {
					financialTabValue.push('Max');
					financialTabValue.push('Min');
				} else {
					$scope.financialFilterOption.financialPeerMinMaxFlag = 'NO';
				}
			}

			if (checkVal == true && val == $scope.cy) {
				year.push(val);
			} else if ((checkVal == undefined || checkVal == false)
					&& val == $scope.cy) {
				var i = year.indexOf($scope.cy);
				year.splice(i, 1);
			}
			if (checkVal == true && val == $scope.cy1) {
				year.push(val);
			} else if (checkVal == false && val == $scope.cy1) {
				var i = year.indexOf($scope.cy1);
				year.splice(i, 1);
			}
			if (checkVal == true && val == $scope.cy2) {
				year.push(val);
			} else if (checkVal == false && val == $scope.cy2) {
				var i = year.indexOf($scope.cy2);
				year.splice(i, 1);
			}

			// added for year issue in output
			year.sort(function(a, b) {
				return b - a
			});

			peerGroupsForFinancialTab = [];
			for (var peer = 0; peer < $scope.financialFilterOption.selectedPeerGroupForFilter.length; peer++) {
				peerGroupsForFinancialTab
						.push($scope.financialFilterOption.selectedPeerGroupForFilter[peer]);

				if (checkVal == true && val == 'peerGroups') {
					if (peer == $scope.financialFilterOption.selectedPeerGroupForFilter.length - 1) {
						var validCommonYear = $scope.updateCommonYear();

						if (!validCommonYear) {
							return;
						}
					}
				}
			}

			peerGroupsForFinancialTab = peerGroupsForFinancialTab.sort();

			var gridCgs = [];
			var ycgmain = new flexiciousNmsp.FlexDataGridColumnGroup();
			gridCgs.push(ycgmain);
			var allheadCols = [];
			var mCol = new flexiciousNmsp.FlexDataGridColumn();
			mCol.setHeaderText("Parameters");
			mCol.setDataField("parameter");
			mCol.headerAlign = "center";
			mCol.setColumnWidthMode("fitToContent");
			mCol.sortable = false;
			mCol.headerWordWrap = true;
			mCol.enableHierarchicalNestIndent = true;
			mCol.headerHorizontalGridLineColor = "0x000000";
			mCol.columnGroupHorizontalGridLineColor = "0x000000";

			allheadCols.push(mCol);

			ycgmain.setColumns(allheadCols);

			for (var p = 0; p < peerGroupsForFinancialTab.length; p++) {

				var ycg = new flexiciousNmsp.FlexDataGridColumnGroup();
				gridCgs.push(ycg);
				ycg.setHeaderText($scope
						.replacePeerGroupName(peerGroupsForFinancialTab[p]));
				peerCol = [ peerGroupsForFinancialTab[p] + "" ];
				var colSubHeader = [];
				for (var k = 0; k < year.length; k++) {
					yearCol = [ year[k] ];
					var allCols = [];
					for (var j = 0; j < yearCol.length; j++) {

						var yearColGrid = new flexiciousNmsp.FlexDataGridColumnGroup();
						// $scope.getPeerGroupYearCount(peerGroupsForFinancialTab[p],yearCol[j]);
						yearColGrid.setHeaderText(yearCol[j]
								+ $scope.getPeerGroupYearCount(
										peerGroupsForFinancialTab[p],
										yearCol[j]));
						yearColGrid.setStyle("textAlign", "right");
						yearColGrid.headerAlign = "center";
						yearColGrid.columnWidthMode = "fitToContent";
						yearColGrid.headerHorizontalGridLineColor = "0x000000";
						colSubHeader.push(yearColGrid);
						col = financialTabValue;

						for (var m = 0; m < financialTabValue.length; m++) {

							var financialValCol = new flexiciousNmsp.FlexDataGridColumn();
							if (financialTabValue.length == 1) {
								financialValCol.setHeaderText(yearCol
										+ $scope.getPeerGroupYearCount(
												peerGroupsForFinancialTab[p],
												yearCol) + " - "
										+ financialTabValue[m]);
							} else {
								financialValCol
										.setHeaderText(financialTabValue[m]);
							}

							var dataFieldCombined = "";
							var dataFieldForYear = "";
							var dataFieldForfinancialVal = '';
							if (col[m] == "Median") {
								dataFieldCombined = "median";
							} else if (col[m] == "Aggregate") {
								dataFieldCombined = "aggregate";
							} else if (col[m] == "Min") {
								dataFieldCombined = "minimum";
							} else if (col[m] == "Max") {
								dataFieldCombined = "maximum";
							}
							var index = -1;
							if (peerGroupsForFinancialTab[p] == 'PeerGroup1') {
								dataFieldForfinancialVal = "PeerGroup1";
								var peerGroup1Arr = $scope.peerGroupWiseYear['PeerGroup1'];
								index = peerGroup1Arr.indexOf(yearCol[j]);

							} else if (peerGroupsForFinancialTab[p] == 'PeerGroup2') {
								dataFieldForfinancialVal = "PeerGroup2";
								var peerGroup2Arr = $scope.peerGroupWiseYear['PeerGroup2'];
								index = peerGroup2Arr.indexOf(yearCol[j]);

							} else if (peerGroupsForFinancialTab[p] == 'PeerGroup3') {
								dataFieldForfinancialVal = "PeerGroup3";
								var peerGroup3Arr = $scope.peerGroupWiseYear['PeerGroup3'];
								index = peerGroup3Arr.indexOf(yearCol[j]);

							} else if (peerGroupsForFinancialTab[p] == 'PeerGroup4') {
								dataFieldForfinancialVal = "PeerGroup4";
								var peerGroup4Arr = $scope.peerGroupWiseYear['PeerGroup4'];
								index = peerGroup4Arr.indexOf(yearCol[j]);
							}

							if (index == 0) {
								dataFieldForYear = "CurrentYear";

							} else if (index == 1) {
								dataFieldForYear = "CurrentYearMinOne";

							} else if (index == 2) {
								dataFieldForYear = "CurrentYearMinTwo";

							}

							financialValCol.setDataField(dataFieldCombined
									+ dataFieldForfinancialVal
									+ dataFieldForYear);
							financialValCol.sortable = false;
							financialValCol.setStyle("textAlign", "right");
							financialValCol.headerAlign = "center";
							financialValCol.headerWordWrap = "true"
							financialValCol.columnWidthMode = "fitToContent";
							financialValCol.headerHorizontalGridLineColor = "0x000000";
							financialValCol.columnGroupHorizontalGridLineColor = "0x000000";
							financialValCol
									.setLabelFunction($scope.largeDynamicGrid_dataGridFormatNumberTabLabelFunction);
							allCols.push(financialValCol);

						}
						yearColGrid.setColumns(allCols);
					}

				}

				ycg.setGroupedColumns(colSubHeader);
			}
			financialTabGrid.getColumnLevel().setGroupedColumns(gridCgs);
			colCount = financialTabGrid._columnLevel._columns.length - 1;

			financialTabGrid.rebuild();
			financialTabGrid.validateNow();

		}

		$scope.replacePeerGroupName = function(name) {
			var replaceName = "";
			if (name == 'PeerGroup1') {
				replaceName = "Peer Group 1";
			} else if (name == 'PeerGroup2') {
				replaceName = "Peer Group 2";
			} else if (name == 'PeerGroup3') {
				replaceName = "Peer Group 3";
			} else if (name == 'PeerGroup4') {
				replaceName = "Peer Group 4";
			}
			return replaceName;
		}

		$scope.getPeerGroupYearCount = function(peerName, yearCol) {
			var yearCount = '';
			angular
					.forEach(
							$scope.peerGroupWiseYearCount,
							function(value, key) {
								if (key == peerName) {
									angular
											.forEach(
													value,
													function(yearvalue, yearkey) {
														if (yearkey == yearCol) {
															if ($scope.financialFilterOption.excludeNegativeNetworth == 'true') {
																yearCount = yearvalue.companyCountWithoutNegativeNetworth;
															} else {
																yearCount = yearvalue.companyCount;
															}

														}
													});
								}
							});
			return ' (' + yearCount + ' cos.)';
		}

		$scope.largeDynamicGrid_dataGridFormatNumberLabelFunction = function(
				item, dgColumn) {
			if (item.parameter.indexOf("Crore") >= 0) {
				if (item.hasOwnProperty(dgColumn.dataField)) {
					var number = item[dgColumn.dataField];
					var largeDynamicGrid_numberFormatter = new flexiciousNmsp.NumberFormatter();
					if (number)
						return largeDynamicGrid_numberFormatter.format(number);

				} else
					return null;
			} else if (item.parameter.indexOf("Crore") < 0
					&& item.parameter.indexOf("(Days)") < 0) {
				var number = item[dgColumn.dataField];
				if (number != null && typeof number === 'number')
					return parseFloat(Math.round(number * 100) / 100)
							.toFixed(1);
			}
			return item[dgColumn.dataField];

		}

		$scope.largeDynamicGrid_dataGridFormatNumberTabLabelFunction = function(
				item, dgColumn) {
			if (item.parameter.indexOf("Crore") >= 0) {
				if (item.hasOwnProperty(dgColumn.dataField)) {
					var number = item[dgColumn.dataField];
					var largeDynamicGrid_numberFormatter = new flexiciousNmsp.NumberFormatter();
					if (number)
						return largeDynamicGrid_numberFormatter.format(number);

				} else
					return null;
			} else if (item.parameter.indexOf("Crore") < 0
					&& item.parameter.indexOf("(Days)") < 0) {
				var number = item[dgColumn.dataField];
				if (number != null && typeof number === 'number')
					return parseFloat(Math.round(number * 100) / 100)
							.toFixed(2);
			}
			return item[dgColumn.dataField];

		}

		$scope.updateCommonYear = function() {
			$scope.resetYearData();
			$scope.yearArr = new Array();
			for ( var i in peerGroupsForFinancial) {
				if (peerGroupsForFinancial.hasOwnProperty(i)) {
					var peerGroupArr = $scope.peerGroupWiseYear[peerGroupsForFinancial[i]];
					$scope.yearArr.push(peerGroupArr);
				}
			}
			if ($scope.yearArr != null && $scope.yearArr.length > 1) {

				var result1 = $scope.yearArr.shift().filter(function(v) {
					return $scope.yearArr.every(function(a) {
						return a.indexOf(v) !== -1;
					});
				});
				if (result1.length == 0) {
					$scope
							.showErrorMessages("Insufficient data for selected Peer group(s). Please broaden your selection.");
					return false;
				}
				if (result1.length >= 1) {
					$scope.cy = result1[0];
				}
				if (result1.length >= 2) {
					$scope.cy1 = result1[1];
				}
				if (result1.length >= 3) {
					$scope.cy2 = result1[2];
				}
			} else {

				if ($scope.yearArr[0].length >= 1) {
					$scope.cy = $scope.yearArr[0][0];
				}
				if ($scope.yearArr[0].length >= 2) {
					$scope.cy1 = $scope.yearArr[0][1];
				}
				if ($scope.yearArr[0].length >= 3) {
					$scope.cy2 = $scope.yearArr[0][2];
				}
			}
			year = [];
			year.push($scope.cy);
			$scope.financialFilterOption.notCheckedCurrentYearVal = true;
			$scope.financialFilterOption.notCheckedCurrentYearMinOneVal = false;
			$scope.financialFilterOption.notCheckedCurrentYearMinTwoVal = false;

			$scope.financialFilterOption.currentYearVal = true;
			$scope.financialFilterOption.currentYearMinOneVal = false;
			$scope.financialFilterOption.currentYearMinTwoVal = false;

			return true;
		}

		$scope.modifyPeerGroup = function() {
			financialValue = [];
			year = [];
			peerGroupsForFinancial = [];
			operationalValue = [];
			yearForOperational = [];
			yearColForOperational = [];
			$scope.compare = false;
		}

		$scope.showListofCompanies = function(type) {

			var filterYearFlag = 'YEAR';
			if (type == 'financial') {
				filterYearFlag = $scope.financialFilterOption.financialType;
			} else if (type == 'rating') {
				filterYearFlag = type;
			}

			$uibModal
					.open({
						templateUrl : 'app/industry/industryBenchmark/comparedListOfCompanies.modal.html',
						controller : 'ComparedListOfCompaniesModalController',
						controllerAs : 'vm',
						size : 'lg',
						resolve : {
							selectedPeerGroups : function() {
								return $scope.selectedPeerGroups;
							},
							filterYearFlag : function() {
								return filterYearFlag;
							},
							excludeNegativeNetworth : function() {
								return $scope.financialFilterOption.excludeNegativeNetworth;
							}
						}
					});
		}

		// To reset financial parameters
		$scope.resetFinancialParameter = function() {
			// $scope.financialFilterOption.financialType = 'YEAR';
			// TODO :: Swapnil : Reset MIN, MAX depending upon peer group
			$scope.financialFilterOption.financialPeerMinMaxFlag = 'NO';
			// TODO :: Swapnil : Reset MEDIAN depending upon peer group
			$scope.financialFilterOption.medianAggFlag = 'median';
			$scope.financialFilterOption.selectedPeerGroupForFilter = [];
			// $scope.financialFilterOption.selectedPeerGroupForFilter.push("PeerGroup1");

			$scope.financialFilterOption.notCheckedCurrentYearVal = true;
			$scope.financialFilterOption.notCheckedCurrentYearMinOneVal = true;
			$scope.financialFilterOption.notCheckedCurrentYearMinTwoVal = true;

			$scope.financialFilterOption.currentYearVal = true;
			$scope.financialFilterOption.currentYearMinOneVal = true;
			$scope.financialFilterOption.currentYearMinTwoVal = true;

		}

		// To reset parameter for 2nd time generate
		$scope.resetBenchmarkOutput = function() {
			$scope.financialFilterOption.excludeNegativeNetworth = 'false';
			$scope.disableOperationalParameter = false;
			$scope.activeTab = 1;
			$scope.operationEmptyDataFlag = false;
			$scope.showResult = false;

			$scope.financialFilterOption.financialType = 'YEAR';
			$scope.financialFilterOption.financialPeerMinMaxFlag = 'NO';
			$scope.financialFilterOption.medianAggFlag = 'median';
			$scope.financialFilterOption.selectedPeerGroupForFilter = [];

			$scope.financialData = null;
			$scope.ratingData = null;
			$scope.operationalData = null;
		}

		// Added By Deepali on 15-Jan-2018 SR-#40455 To export 5 years data
		$scope.exportAllYears = function(Identifier, temptab) {
			$scope.identifier = Identifier;
			var ExportFd = new FormData();
			$scope.getYearSelecetedValue();

			ExportFd.append('selectedPeerGroups', angular
					.toJson($scope.selectedPeerGroups));
			ExportFd.append('financialType',
					$scope.financialFilterOption.financialType);
			ExportFd.append('excludeNegativeNetworth',
					$scope.financialFilterOption.excludeNegativeNetworth);
			ExportFd.append('disableOperationalParameter',
					$scope.disableOperationalParameter);
			if ($scope.identifier == 'Y') {
				$scope.exportAllYear = true;
				var modalid = "#ConfirmationBox";
				$(modalid).modal('hide');

			} else {
				$scope.exportAllYear = false;
				var modalid = "#ConfirmationBox";
				$(modalid).modal('hide');

			}
			if ($scope.exportType == 'excel') {
				ExportFd.append("exportAllYears", $scope.exportAllYear);

				if (temptab === 1) {

					ExportFd.append('yearSelected', $scope.yearSelected);
					var uploadUrl = 'api/industryBenchmark/benchmarkExportData';
				} else if (temptab === 2) {
					ExportFd.append('yearSelected', $scope.yearSelected);
					ExportFd.append('calculationForFlag', formulaFlag);
					var uploadUrl = 'api/industryBenchmarkFinancial/benchmarkExportData';
				}

				$http
						.post(uploadUrl, ExportFd, {
							transformRequest : angular.identity,
							responseType : 'arraybuffer',
							headers : {
								'Content-Type' : undefined,
							}
						})
						.success(
								function(response) {
									$scope.response = response;
									var isIE = false || !!document.documentMode;
									var blob = new Blob(
											[ response ],
											{
												type : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
											});

									if (isIE) {

										window.navigator
												.msSaveOrOpenBlob(blob,
														'Industry Benchmark results.xlsx');

									} else {
										var anchor = angular.element('<a/>');
										var objectUrl = (window.URL || window.webkitURL)
												.createObjectURL(blob);
										anchor.css({
											display : 'none'
										});
										// Make sure it's not visible
										angular.element(document.body).append(
												anchor); // Attach to
										// document
										anchor
												.attr({
													href : objectUrl,
													target : '_blank',
													download : 'Industry Benchmark results.xlsx'
												})[0].click();

										anchor.remove();
									}

								})
						.error(
								function(response, status, headers, config) {
									vm.entityResponse = response;
									$scope
											.showErrorMessages('Internal Server Error. please write to us at productsupport@crisil.com');
								});
				;
			} else if ($scope.exportType == 'pdf') {
				ExportFd.append("exportAllYears", $scope.exportAllYear);

				// var uploadUrl =
				// 'api/industryBenchmarkFinancial/generateExportPdf';

				if ($scope.tabid === 1) {
					ExportFd.append('yearSelected', $scope.yearSelected);
					var uploadUrl = 'api/industryBenchmark/generateExportPdf';
				} else if ($scope.tabid === 2) {
					ExportFd.append('yearSelected', $scope.yearSelected);
					ExportFd.append('calculationForFlag', formulaFlag);
					var uploadUrl = 'api/industryBenchmarkFinancial/generateExportPdf';
				}

				$http
						.post(uploadUrl, ExportFd, {
							transformRequest : angular.identity,
							responseType : 'arraybuffer',
							headers : {
								'Content-Type' : undefined,
							}
						})
						.success(
								function(response) {
									$scope.response = response;

									var isIE = false || !!document.documentMode;
									var blob = new Blob([ response ], {
										type : 'application/pdf'
									});

									if (isIE) {
										window.navigator
												.msSaveOrOpenBlob(blob,
														'Industry Benchmark results.pdf');
									} else {
										/*
										 * var anchor = angular.element('<a/>');
										 * var objectUrl = (window.URL ||
										 * window.webkitURL)
										 * .createObjectURL(blob); anchor
										 * .attr({ href : objectUrl, style :
										 * 'display:none', target : '_self',
										 * download : 'Industry Benchmark
										 * results.pdf' })[0].click();
										 * anchor.remove();
										 */

										var anchor = angular.element('<a/>');

										var objectUrl = (window.URL || window.webkitURL)
												.createObjectURL(blob);
										anchor.css({
											display : 'none'
										});
										// Make sure it's not visible
										angular.element(document.body).append(
												anchor); // Attach to
										// document
										anchor
												.attr({
													href : objectUrl,
													target : '_blank',
													download : 'Industry Benchmark results.pdf'
												})[0].click();

										anchor.remove();
									}

								})
						.error(
								function(response, status, headers, config) {
									vm.entityResponse = response;
									$scope
											.showErrorMessages('Internal Server Error. please write to us at productsupport@crisil.com');

								});
				;
			}

		}
		$scope.getYearSelecetedValue = function() {
			$scope.yearSelected = [];
			if ($scope.financialFilterOption.currentYearVal != false) {
				$scope.yearSelected.push($scope.cy);
			}
			if ($scope.financialFilterOption.currentYearMinOneVal != false) {
				$scope.yearSelected.push($scope.cy1);
			}
			if ($scope.financialFilterOption.currentYearMinTwoVal != false) {
				$scope.yearSelected.push($scope.cy2);
			}
		}
		// End By Deepali on 15-Jan-2018 SR-#40455 To export 5 years data

		// export the benchmark data
		$scope.exportBenchmarkData = function(temptab) {
			if ($scope.tabid == 1
					&& $scope.userSectionAccessData['Benchmarks.Export BM'] != 'Y') {
				$scope
						.showErrorMessages('You are not authorized to use the export feature. Please contact Administrator.');
			} else if ($scope.tabid == 2
					&& $scope.userSectionAccessData['Benchmarks.Export Benchmark Financial'] != 'Y') {
				$scope
						.showErrorMessages('You are not authorized to use the export feature. Please contact Administrator.');
			} else {
				$scope.getYearSelecetedValue();
				$scope.exportType = 'excel';
				var fd = new FormData();
				fd.append('selectedPeerGroups', angular
						.toJson($scope.selectedPeerGroups));
				fd.append('financialType',
						$scope.financialFilterOption.financialType);
				fd.append('excludeNegativeNetworth',
						$scope.financialFilterOption.excludeNegativeNetworth);
				fd.append('disableOperationalParameter',
						$scope.disableOperationalParameter);
				if ($scope.tabid === 1) {
					fd.append('yearSelected', $scope.yearSelected);
					var uploadUrl = 'api/industryBenchmark/getYearsForExportBenchmarkData';
				} else if ($scope.tabid === 2) {
					var uploadUrl = 'api/industryBenchmarkFinancial/getYearsForExportBenchmarkData';
				}
				$http
						.post(uploadUrl, fd, {
							transformRequest : angular.identity,
							headers : {
								'Content-Type' : undefined
							}
						})
						.success(
								function(response) {
									$scope.peers = [];
									$scope.peerNo = "";
									$scope.response = response;
									$scope.peers = $scope.response.Peer;
									if ($scope.peers.length > 0
											&& ($scope.financialFilterOption.financialType != 'SAMPLE')) {
										for (var i = 0; i < $scope.peers.length; i++) {
											if ($scope.peerNo == "") {
												$scope.peerNo = $scope.peers[i];
											} else {
												$scope.peerNo = $scope.peerNo
														+ "," + $scope.peers[i];
											}
										}
										var modalid = "#ConfirmationBox";
										$(modalid).modal('show');
									} else {
										$scope.exportAllYear = false;
										fd.append("exportAllYears",
												$scope.exportAllYear);

										if (temptab === 1) {
											var uploadUrl = 'api/industryBenchmark/benchmarkExportData';
										} else if (temptab === 2) {
											fd.append('calculationForFlag',
													formulaFlag);
											fd.append('yearSelected', $scope.yearSelected);
											var uploadUrl = 'api/industryBenchmarkFinancial/benchmarkExportData';
										}

										$http
												.post(
														uploadUrl,
														fd,
														{
															transformRequest : angular.identity,
															responseType : 'arraybuffer',
															headers : {
																'Content-Type' : undefined,
															}
														})
												.success(
														function(response) {
															$scope.response = response;
															var isIE = false || !!document.documentMode;
															var blob = new Blob(
																	[ response ],
																	{
																		type : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
																	});

															if (isIE) {

																window.navigator
																		.msSaveOrOpenBlob(
																				blob,
																				'Industry Benchmark results.xlsx');

															} else {
																var anchor = angular
																		.element('<a/>');
																var objectUrl = (window.URL || window.webkitURL)
																		.createObjectURL(blob);
																anchor
																		.css({
																			display : 'none'
																		});
																// Make sure
																// it's not
																// visible
																angular
																		.element(
																				document.body)
																		.append(
																				anchor); // Attach
																// to
																// document
																anchor
																		.attr({
																			href : objectUrl,
																			target : '_blank',
																			download : 'Industry Benchmark results.xlsx'
																		})[0]
																		.click();

																anchor.remove();
															}

														})
												.error(
														function(response,
																status,
																headers, config) {
															vm.entityResponse = response;
															$scope
																	.showErrorMessages('Internal Server Error. please write to us at productsupport@crisil.com');
														});
										;
									}
								})

				// End Added Deepali on 12-jan-2018

			}
		}

		// Export pdf generate
		$scope.generateExportPdf = function(tabid) {
			$scope.isopen = false;

			if ($scope.tabid == 1
					&& $scope.userSectionAccessData['Benchmarks.Export BM'] != 'Y') {
				$scope
						.showErrorMessages('You are not authorized to use the export feature. Please contact Administrator.');
			} else if ($scope.tabid == 2
					&& $scope.userSectionAccessData['Benchmarks.Export Benchmark Financial'] != 'Y') {
				$scope
						.showErrorMessages('You are not authorized to use the export feature. Please contact Administrator.');
			} else {
				$scope.getYearSelecetedValue();
				$scope.exportType = 'pdf';
				var fd = new FormData();
				fd.append('selectedPeerGroups', angular
						.toJson($scope.selectedPeerGroups));// changed for
				// common count // issue
				fd.append('financialType',
						$scope.financialFilterOption.financialType);
				fd.append('excludeNegativeNetworth',
						$scope.financialFilterOption.excludeNegativeNetworth);
				fd.append('disableOperationalParameter',
						$scope.disableOperationalParameter);

				if (tabid === 1) {

					fd.append('yearSelected', $scope.yearSelected);
					var uploadUrl = 'api/industryBenchmark/getYearsForExportBenchmarkData';
				} else if (tabid === 2) {
					var uploadUrl = 'api/industryBenchmarkFinancial/getYearsForExportBenchmarkData';
				}

				$http
						.post(uploadUrl, fd, {
							transformRequest : angular.identity,
							headers : {
								'Content-Type' : undefined
							}
						})
						.success(
								function(response) {
									$scope.peers = [];
									$scope.peerNo = "";
									$scope.response = response;
									$scope.peers = $scope.response.Peer;
									if ($scope.peers.length > 0) {
										for (var i = 0; i < $scope.peers.length; i++) {
											if ($scope.peerNo == "") {
												$scope.peerNo = $scope.peers[i];
											} else {
												$scope.peerNo = $scope.peerNo
														+ "," + $scope.peers[i];
											}

										}
										var modalid = "#ConfirmationBox";
										$(modalid).modal('show');

									} else {
										$scope.exportAllYear = false;
										fd.append("exportAllYears",
												$scope.exportAllYear);

										if ($scope.tabid === 1) {
											var uploadUrl = 'api/industryBenchmark/generateExportPdf';
										} else if ($scope.tabid === 2) {
											fd.append('calculationForFlag',
													formulaFlag);
											fd.append('yearSelected', $scope.yearSelected);
											var uploadUrl = 'api/industryBenchmarkFinancial/benchmarkExportData';

										}

										$http
												.post(
														uploadUrl,
														fd,
														{
															transformRequest : angular.identity,
															responseType : 'arraybuffer',
															headers : {
																'Content-Type' : undefined,
															}
														})
												.success(
														function(response) {
															$scope.response = response;

															var isIE = false || !!document.documentMode;
															var blob = new Blob(
																	[ response ],
																	{
																		type : 'application/pdf'
																	});

															if (isIE) {
																window.navigator
																		.msSaveOrOpenBlob(
																				blob,
																				'Industry Benchmark results.pdf');
															} else {

																var anchor = angular
																		.element('<a/>');

																var objectUrl = (window.URL || window.webkitURL)
																		.createObjectURL(blob);
																anchor
																		.css({
																			display : 'none'
																		});
																// Make sure
																// it's not
																// visible
																angular
																		.element(
																				document.body)
																		.append(
																				anchor); // Attach
																// to
																// document
																anchor
																		.attr({
																			href : objectUrl,
																			target : '_blank',
																			download : 'Industry Benchmark results.pdf'
																		})[0]
																		.click();

																anchor.remove();
															}

														})
												.error(
														function(response,
																status,
																headers, config) {
															vm.entityResponse = response;
															$scope
																	.showErrorMessages('Internal Server Error. please write to us at productsupport@crisil.com');

														});
										;
									}
								})
			}

		}
		// pdf end

		$scope.benchmarkOutputListOfCompanies = function(selectedPeer, temptab) {

			var fd = new FormData();
			$scope.getYearSelecetedValue();
			fd.append('selectedPeerGroup', angular.toJson(selectedPeer));
			// fd.append('exportAllYears', f);
			fd.append('filterYearFlag',
					$scope.financialFilterOption.financialType);
			fd.append('excludeNegativeNetworth',
					$scope.financialFilterOption.excludeNegativeNetworth);
			if (temptab === 1) {
				fd.append('yearSelected', $scope.yearSelected);
				var uploadUrl = 'api/industryBenchmark/getListOfCompaniesForFinancialCommonYear';
			} else if (temptab === 2) {
				fd.append('yearSelected', $scope.yearSelected);
				var uploadUrl = 'api/industryBenchmarkFinancial/getListOfCompaniesForFinancialCommonYear';

			}

			$http
					.post(uploadUrl, fd, {
						transformRequest : angular.identity,
						headers : {
							'Content-Type' : undefined
						}
					})
					.success(
							function(response) {
								// if(response)

								$uibModal
										.open({
											templateUrl : 'app/industry/industryBenchmark/comparedListOfCompanies.modal.html',
											controller : 'ComparedListOfCompaniesModalController',
											controllerAs : 'vm',
											size : 'lg',
											resolve : {
												selectedPeerGroups : function() {
													return $scope.selectedPeerGroups;
												},
												filterYearFlag : function() {
													return $scope.financialFilterOption.financialType;
												},
												excludeNegativeNetworth : function() {
													return $scope.financialFilterOption.excludeNegativeNetworth;
												},
												selectedPeer : function() {
													return selectedPeer;
												},
												listOfCompanies : function() {
													return response;
												},
												year : function() {
													return $scope.year;
												}
											}
										});

							})
					.error(
							function(response) {
								$scope
										.showErrorMessages('Error occurred while getting companies.');
							});
		}

		// load new change starts
		// To load peer group start
		$scope.getPeerGroupData = function(activeTab) {
			// $scope.selectedPeerGroups = [];
			if (activeTab == 1) {
				var modalid = "#loadmodalid";
				$scope.peerGroupsFromDb = null;
				$scope.getStoredPeerGroupData();
			} else {
				var modalid = "#Finloadmodalid";
				$scope.peerGroupsFromDb = null;
				$scope.getStoredPeerGroupFinancialData();
			}

			$scope.peergrptoloadarr = [];
			$scope.selectedpeerlist = [];
			$(modalid).modal('show');

		}

		$scope.getStoredPeerGroupData = function() {

			IndustryBenchmarkService.getPeerGroupData.all({}, function(data) {
				$scope.peerGroupsFromDb = angular.fromJson(data[0]);
			});
		}

		// For Financial Data

		$scope.getStoredPeerGroupFinancialData = function() {

			IndustryBenchmarkService.getPeerGroupFinancialData.all({},
					function(data) {
						$scope.peerGroupsFromDb = angular.fromJson(data[0]);
					});
		}

		$scope.peergrptoloadarr = [];
		$scope.selectedpeerlist = []
		$scope.loadpeergroupchk = function(response) {

			if (response.loadflag) {
				if ($scope.peergrptoloadarr.length >= 4) {

					$scope
							.removeShowErrorMessages("A maximum of four peer groups can be loaded at the same time, please modify your selection.");
					var idx = $scope.peerGroupsFromDb.indexOf(response);
					$scope.peerGroupsFromDb[idx].loadflag = false;
					return false;
				} else {
					$scope.peergrptoloadarr.push(response);
					$scope.selectedpeerlist.push(response.selectedpeer);
				}

				/*
				 * else if(response.selectedpeer=='' ||
				 * response.selectedpeer==null ) {
				 * 
				 * $scope.removeShowErrorMessages("please select peer group to
				 * load to"); var idx =
				 * $scope.peerGroupsFromDb.indexOf(response);
				 * $scope.peerGroupsFromDb[idx].loadflag = false; return false;
				 * }else {
				 * 
				 * if($scope.selectedpeerlist.indexOf(response.selectedpeer) ==
				 * -1){ $scope.peergrptoloadarr.push(response);
				 * $scope.selectedpeerlist.push(response.selectedpeer); }else {
				 * 
				 * $scope.removeShowErrorMessages("please select another peer
				 * group to load"); var idx =
				 * $scope.peerGroupsFromDb.indexOf(response);
				 * $scope.peerGroupsFromDb[idx].loadflag = false; return false; } }
				 */
			} else {
				$scope.peergrptoloadarr.splice($scope.peergrptoloadarr
						.indexOf(response), 1);
			}
			$scope.peergrptoload = response;
		}

		$scope.clearload = function() {
			$scope.peergrptoloadarr = [];
		}

		$scope.loadpeergroupmodal = function() {
			$scope.selectedPeerGroup = [];
			var validflag = true;

			if ($scope.peergrptoloadarr.length == 0) {
				$scope
						.removeShowErrorMessages("Please select at least one peer group to load.");
				return false;
			}

			$scope.invalidpeernames = [];
			for (var i = 0; i < $scope.peergrptoloadarr.length; i++) {
				if ($scope.peergrptoloadarr[i].selectedpeer == null) {
					$scope.invalidpeernames
							.push($scope.peergrptoloadarr[i].peerName);
					validflag = false;

				}

			}

			if (!validflag) {

				$scope
						.removeShowErrorMessages("Please select where '"
								+ $scope.invalidpeernames
								+ "' filter selection should load, from the peer group dropdown.");
				return false;
			}

			$scope.selectedpeerlist = $scope.peergrptoloadarr
					.map(function(row) {
						return row.selectedpeer;
					});

			for ( var j in $scope.selectedpeerlist) {
				var dulicatepeer = $scope.peergrptoloadarr
						.filter(function(peer) {
							return (peer.selectedpeer == $scope.selectedpeerlist[j]);
						});
				if (dulicatepeer.length > 1) {
					$scope
							.removeShowErrorMessages("Multiple peer groups have the same filters being loaded, please change your selection.");
					validflag = false;
				}

			}

			if (!validflag) {
				return false;
			}

			if (validflag) {
				$("#loadmodalid").modal('hide');
				// var noOfPeerToLoad = $scope.peergrptoloadarr.length;
				var noOfPeerToLoad = 0;
				if ($scope.selectedpeerlist.indexOf("selectedpeergroupone") > -1) {
					noOfPeerToLoad = 1;
				}
				if ($scope.selectedpeerlist.indexOf("selectedpeergrouptwo") > -1) {
					noOfPeerToLoad = 2;
				}
				if ($scope.selectedpeerlist.indexOf("selectedpeergroupthree") > -1) {
					noOfPeerToLoad = 3;
				}
				if ($scope.selectedpeerlist.indexOf("selectedpeergroupfour") > -1) {
					noOfPeerToLoad = 4;
				}

				noOfPeerToLoad = noOfPeerToLoad - 1;// peer 1 directive already
				// loaded
				var peerindex = 1;

				while (noOfPeerToLoad > 0) {
					peerindex++;
					$scope.addPeerGroup(peerindex);
					// /]" +
					noOfPeerToLoad--;
				}

				for ( var i in $scope.peergrptoloadarr) {
					$rootScope.$broadcast("loadPeerGroupFor", {
						peerdata : $scope.peergrptoloadarr[i]
					});
				}
			}

		}

		// financial tab

		$scope.loadpeergroupFinmodal = function() {

			var validflag = true;

			if ($scope.peergrptoloadarr.length == 0) {
				$scope
						.removeShowErrorMessages("Please select at least one peer group to load.");
				return false;
			}

			$scope.invalidpeernames = [];
			for (var i = 0; i < $scope.peergrptoloadarr.length; i++) {
				if ($scope.peergrptoloadarr[i].selectedpeer == null) {
					$scope.invalidpeernames
							.push($scope.peergrptoloadarr[i].peerName);
					validflag = false;

				}

			}

			if (!validflag) {

				$scope
						.removeShowErrorMessages("Please select where '"
								+ $scope.invalidpeernames
								+ "' filter selection should load, from the peer group dropdown.");
				return false;
			}

			$scope.selectedpeerlist = $scope.peergrptoloadarr
					.map(function(row) {
						return row.selectedpeer;
					});

			for ( var j in $scope.selectedpeerlist) {
				var dulicatepeer = $scope.peergrptoloadarr
						.filter(function(peer) {
							return (peer.selectedpeer == $scope.selectedpeerlist[j]);
						});
				if (dulicatepeer.length > 1) {
					$scope
							.removeShowErrorMessages("Multiple peer groups have the same filters being loaded, please change your selection.");
					validflag = false;
				}

			}

			if (!validflag) {
				return false;
			}

			if (validflag) {
				$("#Finloadmodalid").modal('hide');
				// var noOfPeerToLoad = $scope.peergrptoloadarr.length;
				var noOfPeerToLoad = 0;
				if ($scope.selectedpeerlist.indexOf("selectedpeergroupone") > -1) {
					noOfPeerToLoad = 1;
				}
				if ($scope.selectedpeerlist.indexOf("selectedpeergrouptwo") > -1) {
					noOfPeerToLoad = 2;
				}
				if ($scope.selectedpeerlist.indexOf("selectedpeergroupthree") > -1) {
					noOfPeerToLoad = 3;
				}
				if ($scope.selectedpeerlist.indexOf("selectedpeergroupfour") > -1) {
					noOfPeerToLoad = 4;
				}

				noOfPeerToLoad = noOfPeerToLoad - 1;// peer 1 directive already
				// loaded
				var peerindex = 1;

				while (noOfPeerToLoad > 0) {
					peerindex++;
					$scope.addPeerGroup(peerindex);
					// /]" +
					noOfPeerToLoad--;
				}

				for ( var i in $scope.peergrptoloadarr) {
					$rootScope.$broadcast("loadPeerGroupForFin", {
						peerdata : $scope.peergrptoloadarr[i]
					});
				}
			}

		}

		$scope.removeShowErrorMessages = function(messageContent) {
			$scope.removeError = true;
			$scope.removeErrorMessages = messageContent;

			$timeout(function() {
				$scope.removeError = false;
				$scope.removeErrorMessages = "";
			}, 5000);
		}

		$scope.removeShowSuccessMessages = function(messageContent) {
			$scope.removeSuccess = true;
			$scope.removeSuccessMessages = messageContent;

			$timeout(function() {
				$scope.ifsuccess = false;
				$scope.successMessages = "";
			}, 10000);
		}

		// to remove selected peer group
		$scope.peerGroupToBeDelete = {};
		$scope.peerGroupToBeDeleteArray = [];

		$scope.removeSelectedPeerGroupFromDb = function(response) {

			$scope.peerGroupToBeDelete = {};
			$scope.peerGroupToBeDeleteArray = [];

			var modalid = "#removemodelid";
			$(modalid).modal('show');

			$scope.peerGroupToBeDelete = response;

		}

		$scope.removeSelectedPeerFinGroupFromDb = function(response) {

			$scope.peerGroupToBeDelete = {};
			$scope.peerGroupToBeDeleteArray = [];

			var modalid = "#finRemovemodelid";
			$(modalid).modal('show');

			$scope.peerGroupToBeDelete = response;

		}

		$scope.removePeerGroup = function() {

			$scope.peerGroupToBeDeleteArray.push($scope.peerGroupToBeDelete);
			var fd = new FormData();
			fd.append('removePeerGroups', angular
					.toJson($scope.peerGroupToBeDeleteArray));

			// Check for duplicate peer names
			var checkDuplicatePeerNamesUrl = 'api/industryBenchmark/removePeerGroups';
			$http
					.post(checkDuplicatePeerNamesUrl, fd, {
						transformRequest : angular.identity,
						headers : {
							'Content-Type' : undefined
						}
					})
					.success(
							function(response) {
								$scope.getStoredPeerGroupData();
								$("#removemodelid").modal('hide');
								$scope
										.removeShowSuccessMessages("Peer group removed successfully.");
							})
					.error(
							function() {
								$scope
										.removeShowErrorMessages("Error occurred while removing peer group.");
							});
		}

		// load new changes ends

		// financial tab

		$scope.removePeerFinGroup = function() {

			$scope.peerGroupToBeDeleteArray.push($scope.peerGroupToBeDelete);
			var fd = new FormData();
			fd.append('removePeerGroups', angular
					.toJson($scope.peerGroupToBeDeleteArray));

			// Check for duplicate peer names
			var checkDuplicatePeerNamesUrl = 'api/industryBenchmarkFinancial/removePeerGroupFinancials';
			$http
					.post(checkDuplicatePeerNamesUrl, fd, {
						transformRequest : angular.identity,
						headers : {
							'Content-Type' : undefined
						}
					})
					.success(
							function(response) {
								$scope.getStoredPeerGroupFinancialData();
								$("#finRemovemodelid").modal('hide');
								$scope
										.removeShowSuccessMessages("Peer group removed successfully.");
							})
					.error(
							function() {
								$scope
										.removeShowErrorMessages("Error occurred while removing peer group.");
							});
		}

		// load new changes ends

		// Financial Tab output data

		// Get rating data
		$scope.fetchRatingFinData = function() {

			var fd = new FormData();
			fd.append('selectedPeerGroups', angular
					.toJson($scope.selectedPeerGroups));
			fd.append('financialType', 'Year');
			fd.append('excludeNegativeNetworth', ' ');

			var uploadUrl = 'api/industryBenchmarkFinancial/getBenchmarkRatingOutputData';
			$http.post(uploadUrl, fd, {
				transformRequest : angular.identity,
				headers : {
					'Content-Type' : undefined
				},
				ignoreLoadingBar : false
			}).success(
					function(response, status, headers, config) {

						$scope.ratingData = response.ratingRowData;

						// To show financial tabset data
						$scope.industryBenchmarkRatingFinOutputData = {
							dataProvider : $scope.ratingData,
							styles : flexiciousNmsp.UIUtils
									.getThemeById('officeblue').styles,
							delegate : $scope
						};
						$timeout(function() {
							$scope.buildGridFinRatingInfo();
						}, 100);
					}).error(function(response, status, headers, config) {
				vm.entityResponse = response;
				$scope.showErrorMessages(vm.entityResponse.description);

			});
		}

		// For output show tabset data for financial tab
		$scope.setTabSetFinData = function(tabsetId) {
			$scope.activeOutputForm = tabsetId;

			if (tabsetId == 1) {

				/*
				 * if ($rootScope.excludeCompanies1 != "" ||
				 * $rootScope.excludeCompanies2 != "" ||
				 * $rootScope.excludeCompanies3 != "" ||
				 * $rootScope.excludeCompanies4 != "") { // changed this for
				 * commo count issue true to false $scope.showCommonToggle =
				 * false; // changed this for common count issue
				 * $scope.financialFilterOption.financialType = 'YEAR'; }
				 * 
				 * if ($scope.financialData == null) {
				 * $scope.fetchCommonDataForFinancials(); }
				 */

			} else if (tabsetId == 2) {

				if ($scope.selectedPeerGroups.length == 4) {
					$("#industryBenchmarkRatingOutputContainer").css({
						'width' : '100%'
					});
				} else if ($scope.selectedPeerGroups.length == 3) {
					$("#industryBenchmarkRatingOutputContainer").css({
						'width' : '90%'
					});
				} else if ($scope.selectedPeerGroups.length == 2) {
					$("#industryBenchmarkRatingOutputContainer").css({
						'width' : '70%'
					});
				} else if ($scope.selectedPeerGroups.length == 1) {
					$("#industryBenchmarkRatingOutputContainer").css({
						'width' : '50%'
					});
				}

				if ($scope.ratingData == null) {
					$scope.fetchRatingFinData();
				}

			} else if (tabsetId == 3) {
				if (!$scope.disableOperationalParameter) {

					if ($scope.operationalData == null) {
						$scope.fetchOperationalData();
					}

				}
			} else if (tabsetId == 4) {
				$scope.fetchFinancialDataGraph(activeTab);
			}
		}

		$scope.buildGridFinRatingInfo = function() {
			var gridCgs = [];
			var ycgmain = new flexiciousNmsp.FlexDataGridColumnGroup();
			gridCgs.push(ycgmain);
			var allheadCols = [];
			var mCol = new flexiciousNmsp.FlexDataGridColumn();
			mCol.setHeaderText("Parameters");
			mCol.setDataField("parameter");
			mCol.headerAlign = "center";
			mCol.setColumnWidthMode("fixed");
			mCol.setWidth(400);
			mCol.sortable = false;
			allheadCols.push(mCol);

			for (var i = 0; i < $scope.selectedPeerGroups.length; i++) {
				var mCols = new flexiciousNmsp.FlexDataGridColumn();
				// mCols.setHeaderText("PeerGroup" + (i + 1));
				// mCols.setDataField("peerGroup" + (i + 1));
				var headerText = $scope.selectedPeerGroups[i].text;
				mCols.setHeaderText(headerText);
				var dataFieldText = "peerGroup"
						+ headerText.substring(headerText.length - 1,
								headerText.length);
				mCols.setDataField(dataFieldText);
				mCols.headerAlign = "center";
				mCols.setStyle("textAlign", "right");
				// mCols.setColumnWidthMode("fitToContent");
				mCols.sortable = false;
				allheadCols.push(mCols);
			}

			ycgmain.setColumns(allheadCols);
			ratingGrid.getColumnLevel().setGroupedColumns(gridCgs);
			ratingGrid.rebuild();
			ratingGrid.validateNow();
		}

		$scope.dynamicColumnsGridForIndustryBenchmarkFinRatingInfo = function(
				evt) {

			ratingGrid = evt.target;
			$scope.buildGridFinRatingInfo();
		};
		$scope.finalYearList1=[];
		$scope.changeCommonYear = function(yearList,checkedFlag,event){
			console.log(yearList);
			
			if($scope.finalYearList.length == 0 && checkedFlag)
			{
				$scope.finalYearList.push(yearList);
			}else if($scope.finalYearList.length < 3 && checkedFlag){
				$scope.finalYearList.push(yearList);
			}else if(!checkedFlag){
				if($scope.finalYearList.indexOf(yearList) != -1){
				$scope.finalYearList.splice($scope.finalYearList.indexOf(yearList));
				$scope.finalYearList1.splice($scope.finalYearList1.indexOf(yearList));
				}
			}else{
				$scope.finalYearList1.push(yearList);
				$scope.commonYearsModel = false;
				event.target.checked = false;
			}
			
			
			 if($scope.finalYearList.length == 3){
				$scope.financialFilterOption.currentYearVal = true;
				$scope.financialFilterOption.currentYearMinOneVal = true
				$scope.financialFilterOption.currentYearMinTwoVal = true;
				$scope.cy=$scope.finalYearList[0];
				$scope.cy1=$scope.finalYearList[1];
				$scope.cy2=$scope.finalYearList[2];
			}else if($scope.finalYearList.length == 2){
				
				$scope.finalYearList[0] == $scope.cy ? $scope.financialFilterOption.currentYearVal = true : $scope.financialFilterOption.currentYearVal = false;
				$scope.finalYearList[1] == $scope.cy1 ? $scope.financialFilterOption.currentYearMinOneVal = true : $scope.financialFilterOption.currentYearMinOneVal = false;
				$scope.finalYearList[1] == $scope.cy2 ? $scope.financialFilterOption.currentYearMinTwoVal = true : $scope.financialFilterOption.currentYearMinTwoVal = false;
				$scope.cy=$scope.finalYearList[0];
				$scope.cy1=$scope.finalYearList[1];
			
			}else if($scope.finalYearList.length == 1){
				$scope.finalYearList[0] == $scope.cy ? $scope.financialFilterOption.currentYearVal = true : $scope.financialFilterOption.currentYearVal = false;
				$scope.finalYearList[1] == $scope.cy1 ? $scope.financialFilterOption.currentYearMinOneVal = true : $scope.financialFilterOption.currentYearMinOneVal = false;
				$scope.finalYearList[1] == $scope.cy2 ? $scope.financialFilterOption.currentYearMinTwoVal = true : $scope.financialFilterOption.currentYearMinTwoVal = false;
				$scope.cy=$scope.finalYearList[0];
			}
			
			
			console.log($scope.finalYearList);
			console.log($scope.commonYearsModel);
			
		}
		
		$scope.setCommonYearData = function(){
			
			$scope.yearSelected = $scope.finalYearList;
			$scope.fetchCommonDataForFinancials();
		}
		
		
		$scope.concelModelOfCommonYear = function(){
			
			$scope.financialFilterOption.financialType ='YEAR';
		
				$scope.proceedComparisonForTab($scope.temptab2);
			
			$('#commonYearPopUp').modal('hide');
		}
		
		$scope.tabInfo = function(tabId){
			$scope.comparePeerGroups(tabId);
			
		}
		
		$scope.tabInfo(1);
	
	}

})();